import { createBrowserRouter, Navigate } from "react-router-dom";

import AuthRoutes from "./AuthRoutes";
import PrivateRoutes from "./PrivateRoutes";

import { ROUTER_PATHS } from "@/shared/constants/routes/router-paths.constants";
import AuthLayout from "../auth/layouts/AuthLayout/AuthLayout";
import ErpLayout from "../erp/layouts/ErpLayout/ErpLayout";

import { LoginPage } from "@/auth/pages/LoginPage";
import {
  BodegasPage,
  CategoryProductPage,
  CreateBodegasPage,
  CreateCategoryProductPage,
  CreateCentroCostoPage,
  CreateEntidadesFinancierasPage,
  CreateIvaPage,
  CreateMarcaProductoPage,
  CreateMedidasProductosPage,
  CreateModeloProductosPage,
  CreatePresentacionesPage,
  CreateUbicacionesPage,
  EntidadesFinancierasPage,
  IvasPage,
  MarcasProductosPage,
  MedidasProductosPage,
  ModelosProductosPage,
  PresentacionPage,
  SeguimientoActividadesVentas,
  UbicacionesPage,
  UpdateBodegasPage,
  UpdateCategoryProductPage,
  UpdateCentroCostoPage,
  UpdateEntidadesFinancierasPage,
  UpdateIvaPage,
  UpdateMarcasProductosPage,
  UpdateMedidasProductoPage,
  UpdateModeloProductoPage,
  UpdatePresentacionesPage,
  UpdateUbicacionesPage,
} from "@/erp";
import {
  CreateObservacionPage,
  ObservacionPage,
  UpdateObservacionPage,
} from "@/erp/administration/observacion/index";
import {
  ResponsableV2Page,
  UpdateResponsablev2Page,
} from "@/erp/administration/responsablev2/index";
import DashboardPage from "@/erp/dashboard/pages/DashboardPage";
import {
  CanalesVentaPage,
  CreateCanalVentaPage,
  UpdateCanalVentaPage,
} from "@/erp/sytem-sttings/canales-venta/pages";
import {
  CitiesPage,
  CreateCityPage,
  UpdateCityPage,
} from "@/erp/sytem-sttings/cities/pages";
import {
  CountriesPage,
  CreateCountryPage,
  UpdateeCountryPage,
} from "@/erp/sytem-sttings/countries/pages";
import {
  CreateTipoInstalacionPage,
  TiposInstalacionesPage,
  UpdateTipoInstalacionPage,
} from "@/erp/sytem-sttings/instalaciones/tipos/pages";
import {
  CreateDocumentTypePage,
  DocumentsTypePage,
  UpdateDocumentTypePage,
} from "@/erp/sytem-sttings/pages";

import {
  CreatePromocionPage,
  PromocionesPage,
  UpdatePromocionPage,
} from "@/erp/sytem-sttings/promociones";
import {
  CreateProvincePage,
  ProvincesPage,
  UpdateProvincePage,
} from "@/erp/sytem-sttings/provinces/pages";

import {
  CreateEmpresaPage,
  EmpresasPage,
  UpdateEmpresaPage,
} from "@/erp/administration/empresas/pages";

import {
  AsignacionesPage,
  CreateAsignacionesPage,
  CreateDepartamentoPage,
  CreateGrupoActivosPage,
  CreateResponsablePage,
  DepartamentosPage,
  GrupoActivosPage,
  UpdateAsignacionesPage,
  UpdateDepartamentoPage,
  UpdateGrupoActivosPage,
  UpdateResponsablePage,
} from "@/erp/activos";
import ActivosModule from "@/erp/activos/ActivosModule";
import {
  ActivosPage,
  CreateActivosPage,
  UpdateActivosPage,
} from "@/erp/activos/activos";
import {
  CreateMantenimientoPage,
  MantenimientoPage,
  UpdateMantenimientoPage,
} from "@/erp/activos/mantenimiento";
import ComisionPageCreateOrEdit from "@/erp/administration/configuracion-comision/page/comision-configuracion-create-edit/ComisionConfiguracionPageCreateOrEdit";
import ComisionPage from "@/erp/administration/configuracion-comision/page/comision-table/ComisionPage";
import {
  CreateGrupoSistemaPage,
  GruposSistemaPage,
  UpdateGrupoSistemaPage,
} from "@/erp/administration/grupo-sistema/pages";
import { CreateICEPage, UpdateICEPage } from "@/erp/administration/ice/pages";
import {
  CreatePaymentMethodPage,
  CreatePaymentMethodV2Page,
  PaymentMethodsPage,
  UpdatePaymentMethodPage,
  UpdatePaymentMethodV2Page,
} from "@/erp/administration/payment-methods/pages";
import {
  CreateTarjetaPage,
  TarjetasPage,
  UpdateTarjetaPage,
} from "@/erp/administration/tarjetas";
import {
  CreateTipoComprobantePage,
  UpdateTipoComprobantePage,
} from "@/erp/administration/tipo-comprobante/pages";
import {
  CreateUsuarioSistemaPage,
  UpdateUsuarioSistemaPage,
  UsuariosSistemaPage,
} from "@/erp/administration/usuarios";
import { CodigosOTPPage } from "@/erp/codigos-otp/pages";
import SolicitudOtpPage from "@/erp/codigos-otp/pages/solicitud-otp/SolicitudOtpPage";

import ComprasModule from "@/erp/compras/ComprasModule";
import { AreasPage, CreateAreaPage, UpdateAreaPage } from "@/erp/compras/areas";
import {
  CreateGroupProveedorPage,
  GroupProovedoresPage,
  UpdateGroupProveedorPage,
} from "@/erp/compras/group-proveedores";
import { CreateOrdenesComprasPage } from "@/erp/compras/ordenesCompra";
import OrdenComprasPagina from "@/erp/compras/ordenesCompra/pages/ordenCompraPage";
import {
  CreatePorcentajeIvaBienesPage,
  PorcentajeIvaBienesPage,
  UpdateBienesIvaRetPage,
} from "@/erp/compras/porcentaje-ret-iva-bienes";
import {
  CreatePorcentajeIvaPage,
  PorcentajeIvaServiciosPage,
  UpdateIvaPageInterface,
} from "@/erp/compras/porcentaje-ret-iva-servicios";
import {
  CreateProveedoresPage,
  ProveedorPage,
  UpdateProveedorPage,
} from "@/erp/compras/proveedores";
import { CreateSolicitudesPedidosPage } from "@/erp/compras/solicitudes-pedidos";
import SolicitudPedidosPagina from "@/erp/compras/solicitudes-pedidos/pages/solicitudesPedidosPage";
import SolicitudUsuariosPedidosPagina from "@/erp/compras/solicitudes-usuarios-pedidos/pages/solicitudesUsuariosPedidosPage";
import {
  CreateTypeComprasPage,
  TiposComprasPage,
  UpdateTypeComprasPage,
} from "@/erp/compras/type-compras";
import { CreateRegimenesPage } from "@/erp/compras/type-regimenes";
import TypeRegimenesPage from "@/erp/compras/type-regimenes/pages/typeRegimenesPages/typeRegiminesPages";
import UpdateTypeRegimen from "@/erp/compras/type-regimenes/pages/updateRegimenesPage/updateRegimenesPage";
import {
  CreateOltPage,
  OLTsPage,
  UpdateOltPage,
} from "@/erp/configuracion-red/olts/pages";
import ContabilidadModule from "@/erp/contabilidad/ContabilidadModule";
import RevisionVoucherPage from "@/erp/contabilidad/revicion-voucher/RevicionVoucherPage";
import VoucherAccionPage from "@/erp/contabilidad/revicion-voucher/voucher-accion/VoucherAccionPage";
import { CargosPage, CreateCargosPage, UpdateCargoPage } from "@/erp/empleados";
import EmpleadosModule from "@/erp/empleados/EmpleadosModule";
import InventarioModule from "@/erp/inventario/InventarioModule";
import {
  CreateGastosPage,
  GastosPage,
  UpdateGastosPage,
} from "@/erp/inventario/gastos/pages";
import ProductoPage from "@/erp/inventario/producto/ProductoPage";
import SolicitudPrevPedidosPagina from "@/erp/inventario/solicitud-pedido-all-actions/SolicitudPedidoAllActicion";
import {
  CreateSubcategoriasPage,
  SubcategoriasPage,
  UpdateSubcategoriasPage,
} from "@/erp/inventario/subcategoriasProductos";
import {
  CreateNapsPage,
  NapsPage,
  UpdateNapsPage,
} from "@/erp/mantenimiento-operacion";
import MantenimientoOperacionModule from "@/erp/mantenimiento-operacion/MantenimientoOperacionModule";
import {
  CreateFlotaPage,
  FlotasPage,
  UpdateFlotaPage,
} from "@/erp/mantenimiento-operacion/flotas/pages";
import {
  CreateNodoPage,
  NodoPage,
  UpdateNodoPage,
} from "@/erp/mantenimiento-operacion/nodo";
import {
  CreatePlanificador,
  PlanificadorCalendarPage,
  PlanificadoresPage,
  PlanificadoresPageView,
} from "@/erp/mantenimiento-operacion/planificadores/pages";
import {
  CreateRadioBasePage,
  RadioBasesPage,
  UpdateRadioBasePage,
} from "@/erp/mantenimiento-operacion/radioBase";
import {
  CreateSectorPage,
  SectorsPage,
  UpdateSectorPage,
} from "@/erp/mantenimiento-operacion/sectors/pages";
import {
  CreateZonePage,
  UpdateZonePage,
  ZonesPage,
} from "@/erp/mantenimiento-operacion/zones/pages";
import {
  ActivacionesInstalacionMainPage,
  CambiosPendientesOTActivacion,
  FotosInstallActivacionITMainPage,
} from "@/erp/operaciones/activaciones/instalaciones/pages";
import {
  ActivacionCambioPuertoPedingPage,
  ActivacionInstallGestionadaPage,
  ActivacionInstallPendingRecoordinadaOTPage,
} from "@/erp/operaciones/activaciones/instalaciones/pages/forms";
import ActivacionInstallPendingPage from "@/erp/operaciones/activaciones/instalaciones/pages/forms/ActivacionInstallPendingPage";
import {
  AgendaRecoordinacionPyLPage,
  UpdateAgendamientoPage,
} from "@/erp/operaciones/agendamiento/pages/forms";
import {
  AgendamientosFinalizadosPyL,
  AgendamientosPagePyL,
} from "@/erp/operaciones/agendamiento/pages/tables";
import { ViewOTInstallRealizadaAuditoriaPage } from "@/erp/operaciones/auditoria/instalaciones/pages";
import AuditoriaInstalacionesOTMainPage from "@/erp/operaciones/auditoria/instalaciones/pages/tables/AuditoriaInstalacionesOTMainPage/AuditoriaInstalacionesOTMainPage";
import { ReviewPreagendaUpdatedPage } from "@/erp/operaciones/preagendamiento/pages/forms";
import UpdatePreagendamientoPage from "@/erp/operaciones/preagendamiento/pages/forms/UpdatePreagendamientoPage";
import {
  OperacionReviewOTInstallPRerechazada,
  OperacionTecnicoInstallMainPage,
} from "@/erp/operaciones/tecnico/instalaciones/pages";
import {
  CreateRouterPage,
  RoutesrPage,
  UpdateRouterPage,
} from "@/erp/router/pages";
import SaleModule from "@/erp/sale/SaleModule";
import AgendamientoVentaPage from "@/erp/sale/asesor/agendamiento/AgendamientoVentaPage";
import InstalacionAsignadaPage from "@/erp/sale/asesor/instalacion/instalacion-asignada/InstalacionAsignadaPage";
import InstalacionRealizadaPage from "@/erp/sale/asesor/instalacion/instalacion-realizada/InstalacionRealizadaPage";
import ProspectoPagina from "@/erp/sale/asesor/prospecto/ProspectoPage";
import SupervicionVentaPage from "@/erp/sale/supervisor_venta/supervision-ventas/SupervisionVentaPage";
import ServicionsModule from "@/erp/servicios/ServicionsModule";
import {
  CreateIpv4Group,
  Ipv4GroupsPage,
  UpdateIpv4Group,
} from "@/erp/sytem-sttings/ipv4-groups/pages";
import {
  CreateIpv6GroupPage,
  Ipv6GroupsPage,
  UpdateIpv6GroupPage,
} from "@/erp/sytem-sttings/ipv6-groups/pages";
import {
  CreatePlanPage,
  PlansPage,
  UpdatePlanPage,
} from "@/erp/sytem-sttings/plans/pages";
import TechnicalSupportModule from "@/erp/technical-support/TechnicalSupportModule";
import { BlockedUsersPassWrongPage } from "@/erp/technical-support/unblock-users/pages";
import TecnicoModule from "@/erp/tecnico/TecnicoModule";
import {
  FotosInstallTecnicoOTMainPage,
  InstalacionAsignadaTecnicoPage,
  InstalacionesTecnicoPage,
  InstalacionRecoordinadaTecnicoPage,
  MigracionesTecnicoPage,
  OrdenServicioCorporativoPage,
  TrasladosTecnico,
  VisitasTecnico,
} from "@/erp/tecnico/orden-trabajo/pages";
import TiketUserModule from "@/erp/tiketUsers/tiketUsersModule";
import TiketsUsuariosPagina from "@/erp/tiketUsers/tikets-users-all-actions/pages/tiketsUsuariosPedidosPage";
import { CreateTiketUsuariosPage } from "@/erp/tiketUsers/tikets-users/pages/create-tiket-usuarios";
import VerTiketsUsuariosPagina from "@/erp/tiketUsers/tikets-users/pages/tiketsUsuariosPedidosPage";
// ROUTER_PATHS ya fue importado mas arriba desde "@/shared/constants/routes/router-paths.constants"
import { CentrosCostosPage, SeguimientoCostePage } from "@/erp";
import AdministracionModule from "@/erp/administration/AdministracionModule";
import CooperativaPage from "@/erp/administration/cooperativa/pages/cooperativaPage/CooperativaPage";
import CreateCooperativaPage from "@/erp/administration/cooperativa/pages/createCooperativa/createCooperativa";
import UpdateCooperativaPage from "@/erp/administration/cooperativa/pages/updateCooperativaPage/updateEntidadesFinancierasPage";
import { ICEPage } from "@/erp/administration/ice/pages";
import { MfaAdminPage } from "@/erp/administration/mfa-admin";
import {
  CreatePaymentMethodProveedorPage,
  PaymentMethodProveedorPage,
  UpdatePaymentMethodProveedorPage,
} from "@/erp/administration/payment-methods-proveedor/pages";
import {
  CreateRadCheckPage,
  RadCheckPageMain,
  UpdateRadCheckPage,
} from "@/erp/administration/radius-check";
import { ReporteUsuariosDashboardPage } from "@/erp/administration/reporte-usuarios";
import {
  CreateParametroPage,
  ParametrosPage,
  UpdateParametroPage,
} from "@/erp/administration/system-parameters/pages";
import TiposComprobantePage from "@/erp/administration/tipo-comprobante/pages/TiposComprobantePage/TiposComprobantePage";
import { AuditorialogPage } from "@/erp/auditoria/auditorialog";
import {
  CreateMotivoPage,
  MotivosPage,
  UpdateMotivoPage,
} from "@/erp/inventario/motivo";
import { PerfilGeneralPage } from "@/erp/perfil";
import ReporteComisionesPage from "@/erp/reportes/comisiones/pages/ReporteComisionesPage";
import CreateProspectoPage from "@/erp/sale/asesor/prospecto/prospecto-crear/CreateProspectoPage";
import { ReporteVentaPageEVA } from "@/erp/sale/supervisor_venta/reporte-venta-eva";
import {
  CreateUnidadesTransportePage,
  UnidadesTransportePage,
  UpdateUnidadesTransportePage,
} from "@/erp/sytem-sttings/UnidadesTransporte";
import {
  CreateMotivoRechazoPage,
  MotivoRechazoPage,
  UpdateMotivoRechazoPage,
} from "@/erp/sytem-sttings/motivo-rechazo";
import { ErrorPagina } from "@/shared/components/ui";
import MaintenancePage from "@/shared/components/ui/MaintenancePage/MaintenancePage";

import {
  ClientesCoorporativosLoader,
  ClientesCoorporativosPage,
  ClientesCoorporativosSave,
} from "@/erp/contabilidad/clientes-corporativos";
import SolicitudFactibilidadCorporativoPage from "@/erp/inventario/solicitud_factibilidad_coporativo/page/solicitud_factibilidad_corporativo_page/SolicitudFactibilidadCorporativoPage";
import NocModule from "@/erp/noc/NocModule";
import AgendamientoNocPage from "@/erp/noc/agendamientonoc/page/agenda_noc/AgendamientoNocPage";
import ViewSolicitudVentaCorporativoPage from "@/erp/noc/solicitud_venta/page/view_solicitud_venta_corporativo_page/ViewSolicitudVentaCorporativoPage";

import PreventaCorporativoPage from "@/erp/venta-corporativa/preventa_corporativo/page/preventa_corporativo_page/PreventaCorporativoPage";
import CreateProspectoCorporativoPage from "@/erp/venta-corporativa/prospecto_corporativo/page/create_prospecto_corporativo_page/CreateProspectoCorporativoPage";
import ProspectoCorporativoPage from "@/erp/venta-corporativa/prospecto_corporativo/page/prospecto_corporativo_page/ProspectoCorporativoPage";
// import FactibilidadCorporativoPage from '@/erp/noc/solicitud_venta/page/factibilidad_corporativo_page/FactibilidadCorporativoPage';
import CreateInventarioSolicitudFactibilidadPage from "@/erp/inventario/solicitud_factibilidad_coporativo/page/create_inventario_solicitud_factibilidad/CreateInventarioSolicitudFactibilidadPage";
import FactibilidadCorporativoPage from "@/erp/noc/solicitud_venta/page/factibilidad_corporativo_page/FactibilidadCorporativoPage";
import BitacoraPylPage from "@/erp/sale/pages/bitacora/page/bitacora_pyl/BitarocaPylPage";
import BitacoraVentaPage from "@/erp/sale/pages/bitacora/page/bitcara_venta/BitarocaVentaPage";
import SolicitudIngresoProspectoPage from "@/erp/sale/pages/solicitud-ingreso-prospecto/SolicitudIngresoProspectoPage";
import SolicicitudDeudaPage from "@/erp/sale/supervisor_venta/solicitud_deuda/SolicicitudDeudaPage";
import VentaCorporativaModule from "@/erp/venta-corporativa/VentaCorporativoModule";
// import PlanCoporativoPge from '@/erp/venta-corporativa/planes_corporativos/page/planes_corporativos_page/PlanCoporativoPage';
// import CreatePlanCorporativoPage from '@/erp/venta-corporativa/planes_corporativos/page/create_planes_corporativos/CreatePlanCorporativoPage';
// import EditarPlanCorporativoPage from '@/erp/venta-corporativa/planes_corporativos/page/editar_planes_corporativos/EditarPlanCorporativoPage';

import PreventasPagina from "@/erp/sale/asesor/preventa/PreventaPage";
import PreventaCreatePage from "@/erp/sale/asesor/preventa/page/preventa-create/PreventaCreatePage";
import PreventaEditPage from "@/erp/sale/asesor/preventa/page/preventa-edit/PreventaEditPage";
import SolicitudVentaExtranejeroPage from "@/erp/sale/supervisor_venta/solicitud_venta_extranjero/page/SolicitudVentaExtranejeroPage";

import { EmpleadosPage } from "@/erp/administration/empleados/pages/EmpleadosPage";
import { UpdateEmpleadoPage } from "@/erp/administration/empleados/pages/UpdateEmpleadosPage";
import { CreateEmpleadosPage } from "@/erp/administration/empleados/pages/createEmpleadosPage";
import { ClienteUpdateDataPage } from "@/erp/clientes/cliente-update-data/pages";
import ConsultaOrdenCompraPage from "@/erp/compras/consultaOrdenCompra/pages/consultaOrdenCompraPage";
import EditarordenCompra from "@/erp/compras/ordenesCompra/pages/EditOrdenCompra/EditOrdenCompra";
import FinalizarOrdenesCompraAbierto from "@/erp/compras/ordenesCompra/pages/finalizarOrdenesCompraPage/finalizarOrdenesCompraAbiertaPage";
import RevisionOrdenesComprasPage from "@/erp/compras/ordenesCompra/pages/revisionOrdenesComprasPage/revisionOrdenesComprasPage";
import ViewReporteCompraPage from "@/erp/compras/reporte-compra/pages/view-reporte-compra-page/ViewReporteCompraPage";
import { RetencionesPage } from "@/erp/compras/retencion/pages/RetencionPage";
import { CreateRetencionPage } from "@/erp/compras/retencion/pages/createRetencion";
import { UpdateRetencionesPage } from "@/erp/compras/retencion/pages/updateRetencionPage";
import RevisionSolicitudIngresoEditar from "@/erp/compras/revision-solicitud-compra/pages/revision-solicitud_ingreso_editar/revisionSolicitudesIngresoEditar";
import RevisionSolicitudIngresoPagina from "@/erp/compras/revision-solicitud-compra/pages/revisionSolicitudesIngresoPage";
import SaveSolicitudesIngreso from "@/erp/compras/solicitudes-ingreso/shared/saveSolicitudesIngreso/saveSolicitudesIngreso";
import PlanCuentaPage from "@/erp/contabilidad/plan-cuenta/PlanCuentaPage";
import CreateregistroFacturas from "@/erp/contabilidad/registro-facturas/page/create-registro-facturas/CreateRegistroFacturas";
import RegistrFacturas from "@/erp/contabilidad/registro-facturas/page/registro-facturas/RegistroFacturas";
import KitInventarioCreate from "@/erp/inventario/kit-inventariable/page/kit-inventariable-create/KitInventarioCreate";
import EditRevisionTransferenciaInventarioPage from "@/erp/inventario/revision_transferencia_inventario/page/edit_recepcion_transferencia_inventario/EditRecepcionTransferenciaInventarioPage";
import TransitoTransferenciaInventarioPage from "@/erp/inventario/revision_transferencia_inventario/page/revision_transferencia_inventario_page/TransitoTransferenciaInventario";
import CreateTomaFisicaPage from "@/erp/inventario/toma_fisica/page/crear_toma_fisica/CreateTomaFisicaPage";
import EditTomaFisicaPage from "@/erp/inventario/toma_fisica/page/edit_toma_fisica/EditTomaFisicaPage";
import TomaFisicaPage from "@/erp/inventario/toma_fisica/page/toma_fisica_page/TomaFisicaPage";
import PendienteActualizarOperacion from "@/erp/mantenimiento-operacion/pendiente-actualizar-operacion/page/pendiente-actualizar-operacion/PendienteActualizarOperacion";
import { PlanificadorCalendarViewPage } from "@/erp/mantenimiento-operacion/planificadores/pages/PlanificadorCalendarViewPage";
import MarketingModule from "@/erp/marketing/MarketingModule";
import RevisionEventoCanjePage from "@/erp/marketing/revision-evento-canje/page/revision-evento-canje-page/RevisionEventoCanjePage";
import CreateSolicitudesEventoCanje from "@/erp/marketing/solicitudes-evento-canje/page/create_solicitudes_evento_canje/CreateSolicitudesEventoCanje";
import EditSolicitudesCanje from "@/erp/marketing/solicitudes-evento-canje/page/editar_solicitudes_evento_canje/EditSolicitudesCanje";
import EditSolicitudesEvento from "@/erp/marketing/solicitudes-evento-canje/page/editar_solicitudes_evento_canje/EditSolicitudesEvento";
import SolicitudEventoCanjePage from "@/erp/marketing/solicitudes-evento-canje/page/solicitud-evento-canje-page/SolicitudEventoCanjePage";
import SolucionEventoCanjePage from "@/erp/marketing/solucion-evento-canje/page/solucion-evento-canje-page/SolucionEventoCanjePage";
import InformeInstalacionProgramadasPagePyl from "@/erp/noc/agendamientonoc/page/informe_instalacion_programadas_pyl/InformeInstalacionProgramadasPylPage";
import ReasignarInstlacionAgendaCorporativaPage from "@/erp/noc/agendamientonoc/page/reasignar_agenda_corp/ReasignarAgendaCorp";
import CreateAgendamientoNoc from "@/erp/noc/createAgendamientoNoc/CreateAgendamientoNoc";
import InspeccionFCorporativoPage from "@/erp/noc/inspeccion-factibilidad/pages/InspeccionFCorporativoPage";
import InspeccionFCorporativoContainer from "@/erp/noc/inspeccion-factibilidad/shared/InspeccionFCorporativoContainer";
import EditSolicitudTecnicoNocAgendaPage from "@/erp/noc/solicitud_tecnico/page/edit_solicitud_tecnico_pymes/EditSolicitudTecnicoNocAgendaPage";
import EditSolicitudTecnicoNocPage from "@/erp/noc/solicitud_tecnico/page/edit_solicitud_tecnico_pymes/EditSolicitudTecnicoNocPage";
import SolicitudTecnicoNocPage from "@/erp/noc/solicitud_tecnico/page/solicitud_tecnico_pymes/SolicitudTecnicoNocPage";
import AprobarSolicitudVentaCorporativoPage from "@/erp/noc/solicitud_venta/page/aprobar_solicitud_venta_corporativo_page/AprobarSolicitudVentaCorporativoPage";
import ViewFactibilidadCorporativoPage from "@/erp/noc/solicitud_venta/page/view_solicitud_factibilidad_corporativo_page/ViewFactibilidadCorporativoPage";
import ViewPreFactibilidadCorporativoPage from "@/erp/noc/solicitud_venta/page/view_solicitud_factibilidad_corporativo_page/ViewPreFactibilidadCorporativoPage";
import ViewSolicitudFactibilidadCorporativoPage from "@/erp/noc/solicitud_venta/page/view_solicitud_factibilidad_corporativo_page/ViewSolicitudFactibilidadCorporativoPage";
import ViewTrazabilidadFactibilidadPage from "@/erp/noc/solicitud_venta/page/view_trazabilidad_factibilidad_page/ViewTrazabilidadFactibilidadPage";
import Activaciones from "@/erp/operaciones/activaciones/Activaciones";
import ActualizarServicioClientePageMain from "@/erp/operaciones/activaciones/actualizacion-servicio-cliente/pages/ActualizarServicioClientePageMain/ActualizarServicioClientePageMain";
import NewServicioClientePage from "@/erp/operaciones/activaciones/actualizacion-servicio-cliente/pages/NewServicioClientePage/NewServicioClientePage";
import UpdateServicioClientePage from "@/erp/operaciones/activaciones/actualizacion-servicio-cliente/pages/UpdateServicioClientePage/UpdateServicioClientePage";
import {
  PuertosDisponiblesPage,
  RevisarPuertosDisponiblesPage,
} from "@/erp/operaciones/activaciones/puertos-disponibles";
import RechazadasTecnicoPEPage from "@/erp/operaciones/activaciones/rechazadas-tecnico-activaciones/page/RechazadasTecnicoActivacionesPage";
import InstalacionCorporativosPage from "@/erp/operaciones/activaciones_corporativos/page/instalacion_corporativo/InstalacionCorporativosPage";
import UpdateInstalacionCorporativoPage from "@/erp/operaciones/activaciones_corporativos/page/update_instalacion_corporativo/UpdateInstalacionCorporativoPage";
import { SeguimientodeActividadesPyL } from "@/erp/operaciones/agendamiento/pages/tables/Seguimiento de Actividades";
import ReportesModule from "@/erp/reportes/ReportesModule";
import ReporteClientesValoresPage from "@/erp/reportes/clientes-valores/pages/ReporteClientesValoresPage";
import EquiposSinMovimientoPage from "@/erp/reportes/equipos-sin-movimiento/pages/equipos-sin-movimiento-page/EquiposSinMovimientoPage";
import AgendamientosFinalizadosPage from "@/erp/sale/asesor/agendamientos-finalizados/AgendamientosFinalizadosPage";
import InformeInstalacionProgramadasVentasPage from "@/erp/sale/asesor/agendamientos-finalizados/page/informe_instalacion_programadas_ventas/InformeInstalacionProgramadasVentasPage";
import ClientesSupervisionVentaPage from "@/erp/sale/asesor/clientes/page/ClientesSupervisionVentaPage";
import InstalacionRechazadoPage from "@/erp/sale/asesor/instalacion/instalacion-rechazada/InstalacionRechazadaPage";
import PendamientoActualizacionPage from "@/erp/sale/asesor/pendiente-actualizacion/PendienteActualizacionPage";
import PreRechazadasVentaPage from "@/erp/sale/asesor/pre-rechazadas/page/PreRechazadasVentaPage";
import PreAgendamientosPage from "@/erp/sale/asesor/pre_agendamiento/PreAgendamientosPage";
import CreatePreagendamientoPage from "@/erp/sale/asesor/pre_agendamiento/page/create_preagendamiento/CreatePreagendamientoPage";
import ReferidoPage from "@/erp/sale/asesor/referido/page/ReferidoPage";
import { AuditoriaVentasHomePage } from "@/erp/sale/auditoria-ventas-home";
import LiberacionValorInstalacionPage from "@/erp/sale/supervisor_venta/liberacion-valor-instalacion/LiberacionValorInstalacionPage";
import ReporteContratosPendientesPage from "@/erp/sale/supervisor_venta/reporte-contratos-pendientes/page/ReporteContratosPendientesPage";
import ReporteVendedoresExternosPage from "@/erp/sale/supervisor_venta/reporte-vendedores-externos-callcenter/page/ReporteVendedoresExternosPage";
import ReporteVentaPage from "@/erp/sale/supervisor_venta/reporte-venta/page/ReporteVentaPage";
import SolicitudContratoFisico from "@/erp/sale/supervisor_venta/solicitud-contrato-fisico/page/SolicitudContratoFisico";
import SolicitudVentaGremiosPage from "@/erp/sale/supervisor_venta/solicitud_gremios/page/SolicitudVentaGremiosPage";
import SupervisionLiberacionVentaProspectoPage from "@/erp/sale/supervisor_venta/supervision-ventas-liberacion-prospecto/page/SupervisionLiberacionVentaProspectoPage";
import SolucionesDigitalesModule from "@/erp/soluciones-digitales/SolucionesDigitales";
import CreateServiciosDigitales from "@/erp/soluciones-digitales/solicitudes-evento-canje/page/create_servicios_digitales/CreateServiciosDigitales";
import EditServiciosDigitales from "@/erp/soluciones-digitales/solicitudes-evento-canje/page/editar_servicios_digitales/EditServiciosDigitales";
import ServiciosDigitalesPage from "@/erp/soluciones-digitales/solicitudes-evento-canje/page/servicios_digitales_page/ServiciosDigitalesPage";
import SoporteCorporativoModule from "@/erp/soporte-corporativo/SoporteCorporativoModule";
import GestionTicketsPage from "@/erp/soporte-corporativo/gestion-tickets/page/GestionTicketsPage";
import SoportePymesModule from "@/erp/soporte_pymes/SoportePymesModule";
import EditAgendamientoSoportePymes from "@/erp/soporte_pymes/agendamiento_sp/page/edit_agendamiento_sp/EditAgendamientoSoportePymes";
import CreateAgendamientoSoportePymesPage from "@/erp/soporte_pymes/preagendamiento_sp/create_preagendamiento_sp/CreateAgendamientoSoportePymesPage";
import PreagendamientoSoportePymesPage from "@/erp/soporte_pymes/preagendamiento_sp/page/preagendamiento_sp/PreagendamientoSoportePymesPage";
import SupervisionVentaCorporativaModule from "@/erp/supervision-venta-corporativa/SupervisionVentaCorporativoModule";
import CreatePlanCorporativoPage from "@/erp/supervision-venta-corporativa/planes-corporativos/page/create-planes-corporativos/CreatePlanCorporativoPage";
import EditarPlanCorporativoPage from "@/erp/supervision-venta-corporativa/planes-corporativos/page/editar-planes-corporativos/EditarPlanCorporativoPage";
import PlanCoporativoPage from "@/erp/supervision-venta-corporativa/planes-corporativos/page/planes_corporativos_page/PlanCorporativoPage";
import SolicitudNuevaLineaCorporativoPage from "@/erp/supervision-venta-corporativa/solicitudes-pendientes/page/solicitud-nueva-linea-corporativo/SolicitudNuevaLineaCorporativo";
import SolicitudesCapacidadCorporativoPage from "@/erp/supervision-venta-corporativa/solicitudes-pendientes/page/solicitudes-capacidad-corporativo/SolicitudesCapacidadCorporativoPage";
import SolicitudesPendientesCorporativosEdit from "@/erp/supervision-venta-corporativa/solicitudes-pendientes/page/solicitudes-pendientes-edit/SolicitudesPendientesCorporativosEdit";
import SolicitudesPendientesCorporativosPage from "@/erp/supervision-venta-corporativa/solicitudes-pendientes/page/solicitudes-pendientes-page/SolicitudesPendientesCorporativosPage";
import InstalacionActualizarTecnicoPage from "@/erp/tecnico/orden-trabajo/pages/forms/InstalacionActualizarTecnicoPage";
import {
  ActCategoriaIncidentePage,
  ActCausalIncidentePage,
  ActSubcategoriaIncidente,
  CategoriaIncidentePage,
  CausalIncidentePage,
  CrearCategoriaIncidentePage,
  CrearCausalIncidentePage,
  CrearSubcategoriaIncidente,
  CreateNuevoTicketPage,
  NuevoTicketPage,
  SubcategoriaIncidentePage,
  UpdateNuevoTicket,
} from "@/erp/tickets-clientes";
import TicketClientesModule from "@/erp/tickets-clientes/TicketClientesModule";
import EstadoVentaCorporativoPage from "@/erp/venta-corporativa/estado_venta/page/EstadoVentaCorporativoPage";
import GestionOportunidadComercialPage from "@/erp/venta-corporativa/gestion-oportunidad-comercial/pages/index/GestionOportunidadComercialPage";
import OportunidadComercialTipoPlan from "@/erp/venta-corporativa/oportunidad-comercial-tipoplan/pages/index/OportunidadComercialTipoPlan";
import CompletarPreventaCorporativoPage from "@/erp/venta-corporativa/preventa_corporativo/page/completar_preventa_corporativa_page/CompletarPreventaCorporativoPage";
import CreatePreventaCorporativo from "@/erp/venta-corporativa/preventa_corporativo/page/create_preventa_corporativa_page/CreatePreventaCorporativa";
import EditPreventaCorporativoPage from "@/erp/venta-corporativa/preventa_corporativo/page/edit_preventa_corporativa_page/EditPreventaCorporativoPage";
import NPreventaProspectoCorporativa from "@/erp/venta-corporativa/preventa_corporativo/page/n_preventa_prospecto_corporativo_page/NPreventaProspectoCorporativa";
import ViewPreventaCorporativoPage from "@/erp/venta-corporativa/preventa_corporativo/page/view_preventa_corporativa_page/ViewPreventaCorporativoPage";
import EditProspectoCorporativoPage from "@/erp/venta-corporativa/prospecto_corporativo/page/edit_prospecto_corporativo_page/EditProspectoCorporativo";
import VentasPymesModule from "@/erp/venta_pymes/VentasPymesModule";
import AgendamientoPymesPage from "@/erp/venta_pymes/agendamiento/page/agendamiento_pymes/AgendamientoPymesPage";
import GestorVentaPymesPage from "@/erp/venta_pymes/gestor_venta/page/gestor_venta_pymes/GestorVentaPymesPage";
import CreatePreagendamientoPymesPage from "@/erp/venta_pymes/preagendamiento/page/create_preagendamiento_pymes_page/CreatePreagendamientoPymesPage";
import PreAgendamientosPymesPage from "@/erp/venta_pymes/preagendamiento/page/preagendamiento_pymes_page/PreAgendamientosPymesPage";
import CreatePreventaPymesPage from "@/erp/venta_pymes/preventa/page/create_preventa_pymes/CreatePreventaPymesPage";
import CreateProspectoPreventaPyemesPage from "@/erp/venta_pymes/preventa/page/create_prospecto_preventa_pymes/CreateProspectoPreventaPyemesPage";
import PreventaPymesPage from "@/erp/venta_pymes/preventa/page/preventa_pymes/PreventaPymesPage";
import CreateProspectoPymesPage from "@/erp/venta_pymes/prospecto/page/create_prospecto_pymes/CreateProspectoPymesPage";
import ProspectoPymesPage from "@/erp/venta_pymes/prospecto/page/prospecto_paymes/ProspectoPymesPage";
// --- Conflicto de merge resuelto: se conservan ambos lados, duplicados se eliminaran despues ---
import AgendaPage from "@/erp/tickets-clientes/agenda/pages/AgendaPage";
import CatalogosPage from "@/erp/tickets-clientes/catalogos/pages/CatalogosPage";
import DashboardSupervisorPage from "@/erp/tickets-clientes/dashboard/pages/DashboardSupervisorPage";
import DetalleTicketPage from "@/erp/tickets-clientes/detalle-ticket/pages/DetalleTicketPage";
import EditarTicketPage from "@/erp/tickets-clientes/detalle-ticket/pages/EditarTicketPage";
import TicketsKnowledgeBasePage from "@/erp/tickets-clientes/documentacion/TicketsKnowledgeBasePage";
import GestionAccesosPage from "@/erp/tickets-clientes/gestion-accesos/pages/GestionAccesosPage";
import CrearMasivoPage from "@/erp/tickets-clientes/masivos/pages/CrearMasivoPage";
import DetalleMasivoPage from "@/erp/tickets-clientes/masivos/pages/DetalleMasivoPage";
import MasivosPage from "@/erp/tickets-clientes/masivos/pages/MasivosPage";
import MigracionSoftnetPage from "@/erp/tickets-clientes/migracion-softnet/pages/MigracionSoftnetPage";
import TicketPage from "@/erp/tickets-clientes/my-ticket/pages/ticket-page/TicketPage";
import PerfilClientePage from "@/erp/tickets-clientes/perfil-cliente/pages/PerfilClientePage";
import RotacionRolesPage from "@/erp/tickets-clientes/rotacion-roles/pages/RotacionRolesPage";
import VisitaModule from "@/erp/visitas/VisitaModule";
import AgendaVisitaDiariaPage from "@/erp/visitas/agenda-visita-diarias/page/agenda-visita-diaria-page/AgendaVisitaDiariaPage";
import TicketPendientesAsignacionPage from "@/erp/visitas/tickets-pendientes-asignacion/page/tickets-pendientes-asignacion-page/TicketPendientesAsignacionPage";
// TicketsInternosPage removido - tickets internos se gestionan en las bandejas existentes
import CreateResponsablev2Page from "@/erp/administration/responsablev2/pages/CreateResponsablePage/CreateResponsablePage";
import ClientesModule from "@/erp/clientes/ClientesModule";
import ClientesBrasPage from "@/erp/clientes/clientes-bras/page/clientes-bras/ClientesBrasPage";
import ClientesPymesPage from "@/erp/clientes/clientes-pymes/page/clientes_pymes/ClientesPymesPage";
import SolicitudContratoClientePymes from "@/erp/clientes/clientes-pymes/page/solicitud_cliente_pymes/SolicitudContratoClientePymes";
import {
  ClienteCorporativoPage,
  ClientesCorporativosMainPage,
} from "@/erp/clientes/corporativos/pages";
import {
  ClienteFibraPage,
  ClientesFibraMainPage,
} from "@/erp/clientes/fibra-optica/pages";
import {
  ClientesWirelessMainPage,
  ClienteWirelessPage,
} from "@/erp/clientes/wireless/pages";
import RecepcionCompraPage from "@/erp/compras/recepcion-compra/pages/RecepcionCompraPage";
import RecepcionCompraCrearPage from "@/erp/compras/recepcion-compra/shared/component/RecepcionCompraCrear";
import CrearSolicitudIngresoPage from "@/erp/compras/solicitudIngreso/page/crearSolicitudIngreso/crearSolicitudIngreso";
import EditSolicitudIngresoPage from "@/erp/compras/solicitudIngreso/page/editSolicitudIngreso/editSolicitudIngresoPage";
import SolicitudIngresoPage from "@/erp/compras/solicitudIngreso/page/solicitudesIngresoPage/solicitudesIngresoPage";
import RevisionSolicitudPedido from "@/erp/compras/solicitudes-usuarios-pedidos/pages/revision-solicitud-pedido/revisionSolicitudPedido";
import BrasPage from "@/erp/configuracion-red/bras/page/brass_page/BrasPage";
import CreateBrasPage from "@/erp/configuracion-red/bras/page/create_bras/CreateBrasPage";
import UpdateBrasPage from "@/erp/configuracion-red/bras/page/update_bras/CreateBrasPage";
import {
  CajaPrimariaPage,
  CreateCajaPrimariaPage,
  UpdateCajaPrimariaPage,
} from "@/erp/configuracion-red/caja-primaria/pages";
import {
  CreateIPV4Page,
  IPV4Page,
  UpdateIPV4Page,
} from "@/erp/configuracion-red/ipv4/pages";
import {
  CreateOperadoraPage,
  OperadoraPage,
  UpdateOperadoraPage,
} from "@/erp/configuracion-red/operadora/pages";
import RadiusMigracionesPage from "@/erp/configuracion-red/radius-migraciones/pages/RadiusMigracionesPage/RadiusMigracionesPage";
import {
  CreateRadiusPage,
  RadiusPage,
  UpdateRadiusPage,
} from "@/erp/configuracion-red/radius/pages";
import { CreateEgresoPage } from "@/erp/inventario/Egresos";
import EgresoPage from "@/erp/inventario/Egresos/pages/EgresoTableDynamic/EgresoTableDynamic";
import CostosPage from "@/erp/inventario/costos/pages/CostosPage/CostosPage";
import { UpdateCostosPage } from "@/erp/inventario/costos/pages/UpdateCostosPage";
import { CreateCostosPage } from "@/erp/inventario/costos/pages/createCostosPage";
import CreateCuadreInventarioPage from "@/erp/inventario/cuadre-inventario/pages/create-cuadre-inventario-page/CreateCuadreInventarioPage";
import CuadreInventarioPage from "@/erp/inventario/cuadre-inventario/pages/cuadre-inventario-page/CuadreInventarioPage";
import EditCuadreInventarioPage from "@/erp/inventario/cuadre-inventario/pages/edit-cuadre-inventario-page/EditCuadreInventarioPage";
import IngresoInventarioHistorialPage from "@/erp/inventario/ingreso-producto/page/IngresoInventarioHistorialPage";
import InventarioManual from "@/erp/inventario/ingreso-producto/page/IngresoInventarioPage";
import KardexPage from "@/erp/inventario/kardex/KardexPage";
import KitInventarioEditPage from "@/erp/inventario/kit-inventariable/page/kit-inventariable-edit/KitInventariableEdit";
import KitInventarioPage from "@/erp/inventario/kit-inventariable/page/kit-inventario/KitInventarioPage";
import CreateInventariablePage from "@/erp/inventario/producto/page/CreateInventariable/CreateInventariablePage";
import UpdateInventarioPage from "@/erp/inventario/producto/page/UpdateInventariable/UpdateInventarioPage";
import CreateProductoServicioPage from "@/erp/inventario/producto_servicio/page/create_producto_servicio/CreateProductoServicioPage";
import ProductoServicioPage from "@/erp/inventario/producto_servicio/page/producto_servicio/ProductoServicioPage";
import UpdateProductoServicioPage from "@/erp/inventario/producto_servicio/page/update_producto_servicio/UpdateProductoServicioPage";
import ReporteStockPage from "@/erp/inventario/reporte-stock/page/ReporteStockPage";
import RevisionSolicitudTransferenciaInventarioAccionPage from "@/erp/inventario/revisision-solicitud-transferencia-inventario/RevisionSolicitudTransferenciaInventarioAccionPage";
import RevisionSolicitudTransferenciaInventarioPage from "@/erp/inventario/revisision-solicitud-transferencia-inventario/RevisionSolicitudTransferenciaInventarioPage";
import SolicitudTransferenciaInventarioPage from "@/erp/inventario/solicitud-transferencia-inventario/SolicitudTransferenciaInventario";
import SolicitudTransferenciaInventarioCreatePage from "@/erp/inventario/solicitud-transferencia-inventario/SolicitudTransferenciaInventarioCreatePage";
import SolicitudIngresoBodegaPagina from "@/erp/inventario/solicitudes-ingreso-bodega/pages/solicitudesIngresoBodegaPage";
import TransferenciaInventarioPage from "@/erp/inventario/transferencia-inventario/TransferenciaInventarioPage";
import EditTransferenciaInventarioPage from "@/erp/inventario/transferencia-inventario/page/edit_transferencia_inventario/EditTransferenciaInventarioPage";
import CreateTrasladoInventarioIngresoPage from "@/erp/inventario/transferencia-inventario/page/transferencia-crear-accion/CreateTrasladoInventarioIngresoPage";
import TrasladoInventarioCrearPage from "@/erp/inventario/transferencia-inventario/page/transferencia-crear-accion/TrasladoInventarioCrearPage";
import TrasladoInventarioAccionPage from "@/erp/inventario/transferencia-inventario/page/transferencia-solicitud-accion/TrasladoInventarioAccionPage";
import CheckInstalacionTecnicoPage from "@/erp/mantenimiento-operacion/instalaciones-tecnicos/page/check-instalacion-tecnico/CheckInstalacionTecnicoPage";
import InstalacionesTecnicosPage from "@/erp/mantenimiento-operacion/instalaciones-tecnicos/page/instalaciones-tecnicos/InstalacionesTecnicosPage";
import EditSolicitudTecnicoPlantaExternaAgendaPage from "@/erp/mantenimiento-operacion/solicitud_tecnico/page/edit_solicitud_tecnico_pymes/EditSolicitudTecnicoPlantaExternaAgendaPage";
import EditSolicitudTecnicoPlantaExternaPage from "@/erp/mantenimiento-operacion/solicitud_tecnico/page/edit_solicitud_tecnico_pymes/EditSolicitudTecnicoPlantaExternaPage";
import SolicitudTecnicoPlantaExternaPage from "@/erp/mantenimiento-operacion/solicitud_tecnico/page/solicitud_tecnico_pymes/SolicitudTecnicoPlantaExternaPage";
import {
  ComentariosObservacionesPreventa,
  SolicitudPreventa,
  VerificacionSolicitudPreventa,
} from "@/erp/operaciones/solicitud-preventa";
import CreateSolicitudPreventa from "@/erp/operaciones/solicitud-preventa/pages/CreateSolicitudPreventaPage/CreateSolicitudPreventaPage";
import { ATSContainerPage, ATSMainPage } from "@/erp/tecnico/ats/pages";
import CuadreTecnicoPage from "@/erp/tecnico/cuadre-tecnico/page/cuadre-tecnico-page/CuadreTecnicoPage";
import InstalacionAsignadaTecnicoCorporativoPage from "@/erp/tecnico/orden-trabajo/pages/forms/InstalacionAsignadaTecnicoCorporativoPage";
import InstalacionRevisarOTPage from "@/erp/tecnico/orden-trabajo/pages/forms/InstalacionRevisarOTPage";
import { RetirosTecnico } from "@/erp/tecnico/orden-trabajo/pages/tables/RetirosTecnico";

import VerOrdenTrabajoNoc from "@/erp/noc/ordenes-trabajo/page/VerOrdenTrabajoNoc";
import CrearOrdenTrabajoNoc from "@/erp/noc/ordenes-trabajo/page/supervisor/CrearOrdenTrabajoNoc";
import EditarOrdenTrabajoNoc from "@/erp/noc/ordenes-trabajo/page/supervisor/EditarOrdenTrabajoNoc";
import OrdenesTrabajoNocPage from "@/erp/noc/ordenes-trabajo/page/supervisor/OrdenesTrabajoNocPage";
import ParametrosOrdenesNocPage from "@/erp/noc/ordenes-trabajo/page/supervisor/ParametrosOrdenesNocPage";
import InformeOrdenTrabajoNoc from "@/erp/noc/ordenes-trabajo/page/tecnico/InformeOrdenTrabajoNoc";
import OrdenesNocTecnicoPage from "@/erp/noc/ordenes-trabajo/page/tecnico/OrdenesNocTecnicoPage";
import ReportesContratosPage from "@/erp/reportes/contratos/pages/ReportesContratosPage";
import ReportesContratosGolondrinasPage from "@/erp/reportes/golondrinas/pages/ReportesContratosGolondrinasPage";
import CoberturaCorporativaPage from "@/erp/venta-corporativa/cobertura-corporativa/page/CoberturaCorporativaPage";

import GeneradorSeriesPage from "@/erp/inventario/generador-series/page/GeneradorSeriesPage";
import ReporteActividadInventarioPage from "@/erp/reportes/actividad-inventario/pages/ReporteActividadInventarioPage";

import { CampanasModule } from "@/erp/campanas/CampanasModule";
import { CobranzasPage } from "@/erp/campanas/cobranzas";
import { FidelizacionCampanaPage } from "@/erp/campanas/fidelizacion-campana";
import { FirmaAdendumPage } from "@/erp/campanas/firma-adendum";
import { CampanasPage } from "@/erp/campanas/migracion/pages/CampanasPage";
import {
  ServiceProfilePage,
  UpdateServiceProfilePage,
} from "@/erp/configuracion-red/service-profile/pages";
import { ReingresoSeriePage } from "@/erp/contabilidad/reingreso-serie";
import ParametrosIncidenciaCrearPage from "@/erp/noc/ordenes-trabajo/page/supervisor/ParametrosIncidenciaCrearPage";
import ParametrosTipoActividadCrearPage from "@/erp/noc/ordenes-trabajo/page/supervisor/ParametrosTipoActividadCrearPage";
import {
  ActivacionesTrasladoMainPage,
  ActivacionTrasladoGestionadaPage,
  ActivacionTrasladoPendingPage,
} from "@/erp/operaciones/activaciones/traslados";
import {
  ActivacionesVisitaGestionadaPage,
  ActivacionesVisitaMainPage,
  ActivacionesVisitaPendingPage,
} from "@/erp/operaciones/activaciones/visitas";
import { OrdenServicioTrasladoPage } from "@/erp/orden-servicio/orden-servicio-traslado";
import OrdenServicioAgendamientoPage from "@/erp/orden-servicio/orden-servicio-traslado/pages/orden-servicio-agendamiento-page/SaveOrdenServicioAgendamiento";
import OrdenServicioVisitaAgendamientoPage from "@/erp/orden-servicio/orden-servicio-visita/pages/orden-servicio-agendamiento-page/OrdenServicioVisitaAgendamiento";
import OrdenServicioVisitaPage from "@/erp/orden-servicio/orden-servicio-visita/pages/orden-servicio-visita-page/OrdenServicioVisitaPage";
import OrdenServicioGeneralPage from "@/erp/orden-servicio/orden-servicio/pages/orden-servicio-general-page/OrdenServicioGeneralPage";
import CoberturaNapsPage from "@/erp/venta-corporativa/cobertura-naps/page/CoberturaNapsPage";
import SolucionCosteadaPage from "@/erp/venta-corporativa/solucion_costeada/page/solucion_costeada_page/SolucionCosteadaPage";
import SolucionCosteadaVer from "@/erp/venta-corporativa/solucion_costeada/page/solucion_costeada_ver/SolucionCosteadaVer";
//CONTROL CAMBIOS
import EditarSolicitudPedido from "@/erp/compras/solicitudes-pedidos/pages/editarSolicitudPedido/editarSolicitudPedido";
import {
  AprobadorescontrolcambiosPage,
  AprobadoresPage,
  AreascontrolcambiosPage,
  CreateAreascontrolcambiosPage,
  UpdateAreascontrolcambiosPage,
} from "@/erp/controlcambios/areascontrolcambios";
import {
  CambiosPage,
  CreateCambioServicePage,
  MisAprobacionesPage,
  MisCambiosPage,
  UpdateCambioServicePage,
  VerCambiosServicePage,
} from "@/erp/controlcambios/cambio-service";
import ControlCambiosModule from "@/erp/controlcambios/cambio-service/ControlCambiosModule";
import {
  CreateNotificacionPage,
  NotificacionPage,
  UpdateNotificacionPage,
} from "@/erp/controlcambios/notificacion";
import {
  CreateResponsableControlCambiosPage,
  ResponsablePage,
  UpdateResponsableControlCambiosPage,
} from "@/erp/controlcambios/responsable-controlcambios";
import {
  CreateServidorControlCambiosPage,
  ServidorPage,
  UpdateServidorControlCambiosPage,
} from "@/erp/controlcambios/servidores";
import {
  CreateTipoAccionPage,
  TipoAccionPage,
  UpdateTipoAccionPage,
} from "@/erp/controlcambios/tipo-accion";
import {
  CreateTipoMetricaPage,
  TipoMetricaPage,
  UpdateTipoMetricaPage,
} from "@/erp/controlcambios/tipo-metrica";
import {
  CreateTipoRiesgoPage,
  TipoRiesgoPage,
  UpdateTipoRiesgoPage,
} from "@/erp/controlcambios/tipo-riesgo";
import TransferenciaInventarioPedidoPage from "@/erp/inventario/transferencia-inventario/page/transferencia-crear-accion/TransferenciaInventarioPedidoPage";
import ReporteAgendamientosPylPage from "@/erp/operaciones/agendamiento/pages/report/ReporteAgendamientosPylPage";

import ConfiguracionTransitoPage from "@/erp/inventario/configuracion-transito/pages/ConfiguracionTransito";
import ParametrosTipoActividadEditarPage from "@/erp/noc/ordenes-trabajo/page/supervisor/ParametrosTipoActividadEditarPage";
import RecepcionEquiposAdminPage from "@/erp/recepcion-equipos/pages/RecepcionEquiposAdminPage";

import { GestionInventarioCuadrePage } from "@/erp/contabilidad/gestion-inventario-cuadre";

import { NotificacionInventarioPage } from "@/erp/inventario/notificacion-inventario";
import { CreateNotificacionTrasladoPage } from "@/erp/inventario/notificacion-inventario/pages/create-notificacion-traslado-page/CreateNotificacionTrasladoPage";
import ReporteConsultasPorTipoPage from "@/erp/reportes/consultas-por-tipo/pages/ReporteConsultasPorTipoPage";
import ReporteConsultasPorNapPage from "@/erp/tecnico/reportes/pages/ConsultasPorNap";
const AppRouter = createBrowserRouter([
  ////* Auth
  {
    path: "/auth",
    element: (
      <AuthRoutes>
        <AuthLayout />
      </AuthRoutes>
    ),
    children: [{ path: "login", element: <LoginPage /> }],
  },

  ////* Documentación / Base de conocimiento (pestaña nueva, sin el layout ERP)
  {
    path: "/documentacion/tickets",
    element: (
      <PrivateRoutes>
        <TicketsKnowledgeBasePage />
      </PrivateRoutes>
    ),
  },

  ////* Private Routes
  {
    path: "/",
    element: (
      <PrivateRoutes>
        <ErpLayout />
      </PrivateRoutes>
    ),
    errorElement: <ErrorPagina />,

    children: [
      ////*
      {
        path: "/mantenimiento", // Ruta para la página de mantenimiento
        element: <MaintenancePage />,
      },
      //////////* Dashboard ---------------------------
      {
        path: "/dashboard",
        element: <DashboardPage />,
      },
      {
        path: "/",
        element: <Navigate to={"/dashboard"} replace />,
      },
      {
        path: "*",
        element: <Navigate to={"/dashboard"} />,
      },

      //////////* Perfil ---------------------------
      {
        path: ROUTER_PATHS.perfil.root,
        element: <PerfilGeneralPage />,
      },
      ///**Solicitud Preventa Cliente */
      {
        path: ROUTER_PATHS.solicitud_preventa.root,
        element: <SolicitudPreventa />,
      },
      {
        path: ROUTER_PATHS.solicitud_preventa.solicitudCrear,
        element: <CreateSolicitudPreventa />,
      },
      {
        path: ROUTER_PATHS.solicitud_preventa.solicitudVerificarsolicitud,
        element: <VerificacionSolicitudPreventa />,
      },
      {
        path: ROUTER_PATHS.solicitud_preventa.solicitudCrearComentario,
        element: <ComentariosObservacionesPreventa />,
      },
      //**CONTROL DE CAMBIOS */
      {
        path: ROUTER_PATHS.control_cambios.root,
        element: <ControlCambiosModule />,
        children: [
          //cambio-service
          {
            path: ROUTER_PATHS.control_cambios.cambioServicenav,
            element: <CambiosPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.misCambiosNav,
            element: <MisCambiosPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.cambioServiceCrear,
            element: <CreateCambioServicePage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.cambioServiceEditar,
            element: <UpdateCambioServicePage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.cambioServiceVer,
            element: <VerCambiosServicePage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.cambioServiceMisAprobaciones,
            element: <MisAprobacionesPage />,
          },

          ///Areas
          {
            path: ROUTER_PATHS.control_cambios.area,
            element: <AreascontrolcambiosPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.areaCrear,
            element: <CreateAreascontrolcambiosPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.areaEditar,
            element: <UpdateAreascontrolcambiosPage />,
          },
          ///APROBADORES
          {
            path: ROUTER_PATHS.control_cambios.aprobador,
            element: <AprobadoresPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.aprobadorarea,
            element: <AprobadorescontrolcambiosPage />,
          },
          ///NOTIFICACIONES
          {
            path: ROUTER_PATHS.control_cambios.notificacion,
            element: <NotificacionPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.notificacionCrear,
            element: <CreateNotificacionPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.notificacionEditar,
            element: <UpdateNotificacionPage />,
          },
          ///RESPONSABLES
          {
            path: ROUTER_PATHS.control_cambios.responsable,
            element: <ResponsablePage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.responsableCrear,
            element: <CreateResponsableControlCambiosPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.responsableEditar,
            element: <UpdateResponsableControlCambiosPage />,
          },
          ///SERVIDORES
          {
            path: ROUTER_PATHS.control_cambios.servidor,
            element: <ServidorPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.servidorCrear,
            element: <CreateServidorControlCambiosPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.servidorEditar,
            element: <UpdateServidorControlCambiosPage />,
          },
          ///TIPOS DE RIESGO
          {
            path: ROUTER_PATHS.control_cambios.tipoRiesgo,
            element: <TipoRiesgoPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.tipoRiesgoCrear,
            element: <CreateTipoRiesgoPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.tipoRiesgoEditar,
            element: <UpdateTipoRiesgoPage />,
          },
          ///TIPOS DE ACCION
          {
            path: ROUTER_PATHS.control_cambios.tipoAccion,
            element: <TipoAccionPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.tipoAccionCrear,
            element: <CreateTipoAccionPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.tipoAccionEditar,
            element: <UpdateTipoAccionPage />,
          },
          ///TIPOS DE METRICA
          {
            path: ROUTER_PATHS.control_cambios.tipoMetrica,
            element: <TipoMetricaPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.tipoMetricaCrear,
            element: <CreateTipoMetricaPage />,
          },
          {
            path: ROUTER_PATHS.control_cambios.tipoMetricaEditar,
            element: <UpdateTipoMetricaPage />,
          },
        ],
      },
      //////////* Parametrización / Administracion ---------------------------
      {
        path: ROUTER_PATHS.administration.root,
        element: <AdministracionModule />,
        children: [
          ///* Rad Check ---------
          {
            path: ROUTER_PATHS.administration.radCheck,
            element: <RadCheckPageMain />,
          },
          {
            path: ROUTER_PATHS.administration.radCheckCrear,
            element: <CreateRadCheckPage />,
          },
          {
            path: ROUTER_PATHS.administration.radCheckEditar,
            element: <UpdateRadCheckPage />,
          },
          ///* Empresas ---------
          {
            path: "empresas",
            element: <EmpresasPage />,
          },
          {
            path: "empresas/crear",
            element: <CreateEmpresaPage />,
          },
          {
            path: "empresas/editar/:id",
            element: <UpdateEmpresaPage />,
          },
          /**Observaciones */
          {
            path: ROUTER_PATHS.administration.observacion,
            element: <ObservacionPage />,
          },
          {
            path: ROUTER_PATHS.administration.observacionCrear,
            element: <CreateObservacionPage />,
          },
          {
            path: ROUTER_PATHS.administration.observacionEditar,
            element: <UpdateObservacionPage />,
          },
          /**Responsable */
          {
            path: ROUTER_PATHS.administration.responsable,
            element: <ResponsableV2Page />,
          },
          {
            path: ROUTER_PATHS.administration.responsableCrear,
            element: <CreateResponsablev2Page />,
          },
          {
            path: ROUTER_PATHS.administration.responsableEditar,
            element: <UpdateResponsablev2Page />,
          },

          ///* Ivas ---------
          {
            path: ROUTER_PATHS.administration.iva,
            element: <IvasPage />,
          },
          {
            path: ROUTER_PATHS.administration.ivaCrear,
            element: <CreateIvaPage />,
          },
          {
            path: ROUTER_PATHS.administration.ivaEditar,
            element: <UpdateIvaPage />,
          },
          //ICE
          {
            path: ROUTER_PATHS.administration.ICE,
            element: <ICEPage />,
          },
          {
            path: ROUTER_PATHS.administration.ICECrear,
            element: <CreateICEPage />,
          },
          {
            path: ROUTER_PATHS.administration.ICEEditar,
            element: <UpdateICEPage />,
          },
          ///* Metodos de Pago ---------
          {
            path: ROUTER_PATHS.administration.metodoPago,
            element: <PaymentMethodsPage />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoCrear,
            element: <CreatePaymentMethodPage />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoEditar,
            element: <UpdatePaymentMethodPage />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoV2Crear,
            element: <CreatePaymentMethodV2Page />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoV2Editar,
            element: <UpdatePaymentMethodV2Page />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoProveedor,
            element: <PaymentMethodProveedorPage />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoProveedorCrear,
            element: <CreatePaymentMethodProveedorPage />,
          },
          {
            path: ROUTER_PATHS.administration.metodoPagoProveedorEditar,
            element: <UpdatePaymentMethodProveedorPage />,
          },
          ///* Canales de Venta ---------
          {
            path: ROUTER_PATHS.administration.canalVenta,
            element: <CanalesVentaPage />,
          },
          {
            path: ROUTER_PATHS.administration.canalVentaCrear,
            element: <CreateCanalVentaPage />,
          },
          {
            path: ROUTER_PATHS.administration.canalVentaEditar,
            element: <UpdateCanalVentaPage />,
          },

          ///* Promociones ---------
          {
            path: ROUTER_PATHS.administration.promociones,
            element: <PromocionesPage />,
          },
          {
            path: ROUTER_PATHS.administration.promocionesCrear,
            element: <CreatePromocionPage />,
          },
          {
            path: ROUTER_PATHS.administration.promocionesEditar,
            element: <UpdatePromocionPage />,
          },

          ///* Documents Type ---------
          {
            path: ROUTER_PATHS.administration.tiposDocumento,
            element: <DocumentsTypePage />,
          },
          {
            path: ROUTER_PATHS.administration.tiposDocumentoCrear,
            element: <CreateDocumentTypePage />,
          },
          {
            path: ROUTER_PATHS.administration.tiposDocumentoEditar,
            element: <UpdateDocumentTypePage />,
          },
          {
            path: ROUTER_PATHS.administration.area,
            element: <AreasPage />,
          },
          {
            path: ROUTER_PATHS.administration.areaCrear,
            element: <CreateAreaPage />,
          },
          {
            path: ROUTER_PATHS.administration.areaEditar,
            element: <UpdateAreaPage />,
          },
          ///* Recurrencia --------- CHOICE
          // {
          //   path: ROUTER_PATHS.administration.recurrencia,
          //   element: <RecurrenciaPage />,
          // },
          // {
          //   path: ROUTER_PATHS.administration.recurrenciaCrear,
          //   element: <CreateRecurrenciaPage />,
          // },
          // {
          //   path: ROUTER_PATHS.administration.recurrenciaEditar,
          //   element: <UpdateRecurrenciaPage />,
          // },

          ///* Paises ---------
          {
            path: ROUTER_PATHS.administration.paises,
            element: <CountriesPage />,
          },
          {
            path: ROUTER_PATHS.administration.paisesCrear,
            element: <CreateCountryPage />,
          },
          {
            path: ROUTER_PATHS.administration.paisesEditar,
            element: <UpdateeCountryPage />,
          },

          ///* Provincias ---------
          {
            path: ROUTER_PATHS.administration.provincias,
            element: <ProvincesPage />,
          },
          {
            path: ROUTER_PATHS.administration.provinciasCrear,
            element: <CreateProvincePage />,
          },
          {
            path: ROUTER_PATHS.administration.provinciasEditar,
            element: <UpdateProvincePage />,
          },

          ///* Ciudades ---------
          {
            path: ROUTER_PATHS.administration.ciudades,
            element: <CitiesPage />,
          },
          {
            path: ROUTER_PATHS.administration.ciudadesCrear,
            element: <CreateCityPage />,
          },
          {
            path: ROUTER_PATHS.administration.ciudadesEditar,
            element: <UpdateCityPage />,
          },

          ///* Tipo Instalación ---------
          {
            path: ROUTER_PATHS.administration.tiposInstalacion,
            element: <TiposInstalacionesPage />,
          },
          {
            path: ROUTER_PATHS.administration.tiposInstalacionCrear,
            element: <CreateTipoInstalacionPage />,
          },
          {
            path: ROUTER_PATHS.administration.tiposInstalacionEditar,
            element: <UpdateTipoInstalacionPage />,
          },

          ///* Tipo Comprobante ---------
          {
            path: ROUTER_PATHS.administration.tipoComprobante,
            element: <TiposComprobantePage />,
          },
          {
            path: ROUTER_PATHS.administration.tipoComprobanteCrear,
            element: <CreateTipoComprobantePage />,
          },
          {
            path: ROUTER_PATHS.administration.tipoComprobanteEditar,
            element: <UpdateTipoComprobantePage />,
          },

          ///* Codigos OTP ---------
          {
            path: ROUTER_PATHS.administration.codigosOTP,
            element: <CodigosOTPPage />,
          },
          // ================================================
          ///* Grupos de Sistema
          {
            path: ROUTER_PATHS.administration.grupoSistema,
            element: <GruposSistemaPage />,
          },
          {
            path: ROUTER_PATHS.administration.grupoSistemaCrear,
            element: <CreateGrupoSistemaPage />,
          },
          {
            path: ROUTER_PATHS.administration.grupoSistemaEditar,
            element: <UpdateGrupoSistemaPage />,
          },

          ///* Usuarios Sistema
          {
            path: ROUTER_PATHS.administration.usuarios,
            element: <UsuariosSistemaPage />,
          },
          {
            path: ROUTER_PATHS.administration.usuariosCrear,
            element: <CreateUsuarioSistemaPage />,
          },
          {
            path: ROUTER_PATHS.administration.usuariosEditar,
            element: <UpdateUsuarioSistemaPage />,
          },

          ///* MFA Admin
          {
            path: ROUTER_PATHS.administration.mfaAdmin,
            element: <MfaAdminPage />,
          },

          ///* Reporte de Usuarios (dashboard consolidado)
          {
            path: ROUTER_PATHS.administration.reporteUsuarios,
            element: <ReporteUsuariosDashboardPage />,
          },

          ///* System Parameters
          {
            path: ROUTER_PATHS.administration.systemParameters,
            element: <ParametrosPage />,
          },
          {
            path: ROUTER_PATHS.administration.systemParametersCrear,
            element: <CreateParametroPage />,
          },
          {
            path: ROUTER_PATHS.administration.systemParametersEditar,
            element: <UpdateParametroPage />,
          },

          // ================================================

          {
            path: ROUTER_PATHS.administration.centroCosto,
            element: <CentrosCostosPage />,
          },
          {
            path: ROUTER_PATHS.administration.centroCostoCrear,
            element: <CreateCentroCostoPage />,
          },
          {
            path: ROUTER_PATHS.administration.centroCostoEditar,
            element: <UpdateCentroCostoPage />,
          },
          {
            path: ROUTER_PATHS.administration.area,
            element: <AreasPage />,
          },
          {
            path: ROUTER_PATHS.administration.areaCrear,
            element: <CreateAreaPage />,
          },
          {
            path: ROUTER_PATHS.administration.areaEditar,
            element: <UpdateAreaPage />,
          },
          {
            path: ROUTER_PATHS.administration.tipoRegimenes,
            element: <TypeRegimenesPage />,
          },
          {
            path: ROUTER_PATHS.administration.tipoRegimenesCrear,
            element: <CreateRegimenesPage />,
          },
          {
            path: ROUTER_PATHS.administration.tipoRegimenesEditar,
            element: <UpdateTypeRegimen />,
          },
          {
            path: ROUTER_PATHS.administration.departamento,
            element: <DepartamentosPage />,
          },
          {
            path: ROUTER_PATHS.administration.departamento_crear,
            element: <CreateDepartamentoPage />,
          },
          {
            path: ROUTER_PATHS.administration.departamento_editar,
            element: <UpdateDepartamentoPage />,
          },

          ///* Entidad financiera
          {
            path: ROUTER_PATHS.administration.entidadesFinancieras,
            element: <EntidadesFinancierasPage />,
          },
          {
            path: ROUTER_PATHS.administration.entidadesFinancieras_crear,
            element: <CreateEntidadesFinancierasPage />,
          },

          {
            path: ROUTER_PATHS.administration.entidadesFinancieras_editar,
            element: <UpdateEntidadesFinancierasPage />,
          },

          ///* Cooperativa

          {
            path: ROUTER_PATHS.administration.cooperativa,
            element: <CooperativaPage />,
          },
          {
            path: ROUTER_PATHS.administration.cooperativa_crear,
            element: <CreateCooperativaPage />,
          },

          {
            path: ROUTER_PATHS.administration.cooperativa_editar,
            element: <UpdateCooperativaPage />,
          },

          ///* Comision

          {
            path: ROUTER_PATHS.administration.configuracion_comiciones,
            element: <ComisionPage />,
          },
          {
            path: ROUTER_PATHS.administration.configuracion_comiciones_crear,
            element: <ComisionPageCreateOrEdit />,
          },
          {
            path: ROUTER_PATHS.administration.configuracion_comiciones_editar,
            element: <ComisionPageCreateOrEdit />,
          },
          {
            path: ROUTER_PATHS.administration.porcentajes_ret_iva_bienes,
            element: <PorcentajeIvaBienesPage />,
          },
          {
            path: ROUTER_PATHS.administration.porcentajes_ret_iva_bienes_crear,
            element: <CreatePorcentajeIvaBienesPage />,
          },
          {
            path: ROUTER_PATHS.administration.porcentajes_ret_iva_bienes_editar,
            element: <UpdateBienesIvaRetPage />,
          },
          {
            path: ROUTER_PATHS.administration.porcentajes_ret_iva_servicios,
            element: <PorcentajeIvaServiciosPage />,
          },
          {
            path: ROUTER_PATHS.administration
              .porcentajes_ret_iva_servicios_crear,
            element: <CreatePorcentajeIvaPage />,
          },
          {
            path: ROUTER_PATHS.administration
              .porcentajes_ret_iva_servicios_editar,
            element: <UpdateIvaPageInterface />,
          },
          {
            path: ROUTER_PATHS.administration.tarjetas,
            element: <TarjetasPage />,
          },
          {
            path: ROUTER_PATHS.administration.tarjetas_crear,
            element: <CreateTarjetaPage />,
          },
          {
            path: ROUTER_PATHS.administration.tarjetas_editar,
            element: <UpdateTarjetaPage />,
          },
          {
            path: ROUTER_PATHS.administration.motivos,
            element: <MotivosPage />,
          },
          {
            path: ROUTER_PATHS.administration.motivos_crear,
            element: <CreateMotivoPage />,
          },
          {
            path: ROUTER_PATHS.administration.motivos_editar,
            element: <UpdateMotivoPage />,
          },
          {
            path: ROUTER_PATHS.administration.motivos_rechazo,
            element: <MotivoRechazoPage />,
          },
          {
            path: ROUTER_PATHS.administration.motivos_rechazo_crear,
            element: <CreateMotivoRechazoPage />,
          },
          {
            path: ROUTER_PATHS.administration.motivos_rechazo_editar,
            element: <UpdateMotivoRechazoPage />,
          },
          {
            path: ROUTER_PATHS.administration.unidades_transporte,
            element: <UnidadesTransportePage />,
          },
          {
            path: ROUTER_PATHS.administration.unidades_transporte_crear,
            element: <CreateUnidadesTransportePage />,
          },
          {
            path: ROUTER_PATHS.administration.unidades_transporte_editar,
            element: <UpdateUnidadesTransportePage />,
          },

          ///* Auditoría ---------
          /*  {
             path: ROUTER_PATHS.administration.auditoria,
             element: <AuditoriaPage />,
           }, */
          {
            path: ROUTER_PATHS.administration.auditoria,
            element: <AuditorialogPage />,
          },

          ///* Gestión de Accesos (Permisos, Roles, Usuarios) ---------
          {
            path: ROUTER_PATHS.administration.gestionAccesos,
            element: <GestionAccesosPage />,
          },

          ///* Rotación de Roles por Área (calendario semanal)
          {
            path: ROUTER_PATHS.administration.rotacionRoles,
            element: <RotacionRolesPage />,
          },

          ///* Recepción Equipos - Catálogos
          {
            path: ROUTER_PATHS.administration.recepcionEquiposCatalogos,
            element: <RecepcionEquiposAdminPage />,
          },
        ],
      },

      //////////* Ventas
      {
        path: ROUTER_PATHS.ventas.root,
        element: <SaleModule />,
        children: [
          //PROSPECTO
          {
            path: ROUTER_PATHS.ventas.prospectoNav,
            element: <ProspectoPagina />,
          },
          {
            path: ROUTER_PATHS.ventas.prospectoCrear,
            element: <CreateProspectoPage />,
          },

          //REPORTE VENTA EVA
          {
            path: ROUTER_PATHS.supervisionVentas.reporteVentasEva,
            element: <ReporteVentaPageEVA />,
          },

          //PREVENTA
          {
            path: ROUTER_PATHS.ventas.preventasNav,
            element: <PreventasPagina />,
          },
          {
            path: ROUTER_PATHS.ventas.preventasCrear,
            element: <PreventaCreatePage />,
          },
          {
            path: ROUTER_PATHS.ventas.preventasEdit,
            element: <PreventaEditPage />,
          },
          //PREAGENDAMIENTO
          {
            path: ROUTER_PATHS.ventas.preAgendamientoNav,
            element: <PreAgendamientosPage />,
          },

          {
            path: ROUTER_PATHS.ventas.agendamientoCrear,
            element: <CreatePreagendamientoPage />,
          },

          //PREAGENDAMIENTO AGENDADAS
          {
            path: ROUTER_PATHS.ventas.agendamientoAgendadoNav,
            element: <AgendamientoVentaPage />,
          },
          //AGENDADAS FINALIZADAS
          {
            path: ROUTER_PATHS.ventas.agendamientoFinalizadoAgendadoNav,
            element: <AgendamientosFinalizadosPage />,
          },

          {
            path: ROUTER_PATHS.ventas.agendamientoReporteNav,
            element: <InformeInstalacionProgramadasVentasPage />,
          },
          //SEGUIMIENTO DE ACTIVIDADES
          {
            path: ROUTER_PATHS.supervisionVentas.seguimientoActividadesNav,
            element: <SeguimientoActividadesVentas />,
          },
          //PREAGENDAMIENTO RECHAZADOS POR PYL
          /* {
            path: ROUTER_PATHS.ventas.preagendamientoRechazadosNav,
            element: <PreagendamientoGeneralPage />,
          }, */

          //PENDIENTE ACTUALIZACION
          {
            path: ROUTER_PATHS.ventas.agendamientoPendienteActualizacionNav,
            element: <PendamientoActualizacionPage />,
          },

          //ACTUALIZARON PREAGENDAMIENTO
          /* {
            path: ROUTER_PATHS.ventas.agendamientoActualizarDoc,
            element: <ReachazoDocumentoPage />,
          },
          {
            path: ROUTER_PATHS.ventas.agendamientoActualizarInfo,
            element: <RechazoDatoPage />,
          }, */

          //INSTALACION
          {
            path: ROUTER_PATHS.ventas.instalacionAsignadoNav,
            element: <InstalacionAsignadaPage />,
          },

          {
            path: ROUTER_PATHS.ventas.instalacionRealizadoNav,
            element: <InstalacionRealizadaPage />,
          },

          {
            path: ROUTER_PATHS.ventas.instalacionRechazadoNav,
            element: <InstalacionRechazadoPage />,
          },

          //REFERIDO
          {
            path: ROUTER_PATHS.ventas.referidosNav,
            element: <ReferidoPage />,
          },
          ///BITACORA
          {
            path: ROUTER_PATHS.ventas.bitacoraVentasNav,
            element: <BitacoraVentaPage />,
          },
          ///AUDITORIA VENTAS
          {
            path: ROUTER_PATHS.ventas.auditoriaVentasNav,
            element: <AuditoriaVentasHomePage />,
          },

          //PreRechazadas
          {
            path: ROUTER_PATHS.ventas.preRechazadosVentasNav,
            element: <PreRechazadasVentaPage />,
          },

          //SUPERVISOR DE VENTAS - SUPERVISIÓN DE VENTAS - SUPERVISION DE VENTAS
          {
            path: ROUTER_PATHS.ventas.prospectoNav,
            element: <ProspectoPagina />,
          },
          {
            path: ROUTER_PATHS.ventas.preventasNav,
            element: <PreventasPagina />,
          },
          {
            path: ROUTER_PATHS.ventas.solicitudIngresoProspectoNav,
            element: <SolicitudIngresoProspectoPage />,
          },
          {
            path: ROUTER_PATHS.supervisionVentas.liberacionVentasLineaNav,
            element: <SupervicionVentaPage />,
          },
          {
            path: ROUTER_PATHS.supervisionVentas.liberacionVentaProspectoNav,
            element: <SupervisionLiberacionVentaProspectoPage />,
          },

          {
            path: ROUTER_PATHS.supervisionVentas.solicitudContratoFisicoNav,
            element: <SolicitudContratoFisico />,
          },
          {
            path: ROUTER_PATHS.supervisionVentas.solicitudAprobacionCodigosOTP,
            element: <SolicitudOtpPage />,
          },

          {
            path: ROUTER_PATHS.supervisionVentas
              .solicitudLiberacionValorInstalacionNav,
            element: <LiberacionValorInstalacionPage />,
          },

          ///* Corperativos
          // {
          //   path: ROUTER_PATHS.ventas.prospectoCrearCorporativo,
          //   element: <CreateProspectoCorporativoPage />,
          // },
          // {
          //   path: ROUTER_PATHS.ventas.prospectoCorporativoNav,
          //   element: <ProspectoCorporativoPage />,
          // },
          // {
          //   path: ROUTER_PATHS.ventas.preventaCorporativoNav,
          //   element: <PreventaCorporativoPage />,
          // },
          // {
          //   path: ROUTER_PATHS.ventas.preventaCorporativoCrear,
          //   element: <CreatePreventaCorporativo />,
          // },

          // {
          //   path: ROUTER_PATHS.ventas.preventaCorporativoEdit,
          //   element: <EditPreventaCorporativoPage />,
          // },

          // {
          //   path: ROUTER_PATHS.ventas.preventaCorporativoView,
          //   element: <ViewSolicitudVentaCorporativoPage />,
          // },

          /* {
            path: ROUTER_PATHS.supervisionVentas
              .reporteSolicitudPasarDeudaNav,
            element: <SolicicitudDeudaPage />,
          }, */
          {
            path: ROUTER_PATHS.supervisionVentas.reporteSolicitudPasarDeudaNav,
            element: <SolicicitudDeudaPage />,
          },

          {
            path: ROUTER_PATHS.supervisionVentas.clientesServicio,
            element: <ClientesSupervisionVentaPage />,
          },
          {
            path: ROUTER_PATHS.supervisionVentas.solicitudExtranjeroNav,
            element: <SolicitudVentaExtranejeroPage />,
          },
          {
            path: ROUTER_PATHS.supervisionVentas.solicitudPromoGremiosNav,
            element: <SolicitudVentaGremiosPage />,
          },
        ],
      },
      //////////* Ventas Pymes ---------------------------
      {
        path: ROUTER_PATHS.ventasPymes.root,
        element: <VentasPymesModule />,
        children: [
          ///* Prospecto
          {
            path: ROUTER_PATHS.ventasPymes.prospectoNav,
            element: <ProspectoPymesPage />,
          },
          {
            path: ROUTER_PATHS.ventasPymes.prospectoCreateNav,
            element: <CreateProspectoPymesPage />,
          },

          ///* preventa
          {
            path: ROUTER_PATHS.ventasPymes.preventaCreate,
            element: <CreatePreventaPymesPage />,
          },
          {
            path: ROUTER_PATHS.ventasPymes.preventaNav,
            element: <PreventaPymesPage />,
          },
          {
            path: ROUTER_PATHS.ventasPymes.preventaProspectoCreate,
            element: <CreateProspectoPreventaPyemesPage />,
          },
          ///* preagendamiento
          {
            path: ROUTER_PATHS.ventasPymes.preagendamientoCreate,
            element: <CreatePreagendamientoPymesPage />,
          },
          {
            path: ROUTER_PATHS.ventasPymes.preagendamientoNav,
            element: <PreAgendamientosPymesPage />,
          },

          ///* agendamiento
          {
            path: ROUTER_PATHS.ventasPymes.agendamientoNav,
            element: <AgendamientoPymesPage />,
          },

          ///* gestor de venta
          {
            path: ROUTER_PATHS.ventasPymes.gestorVenta,
            element: <GestorVentaPymesPage />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.soportePymes.root,
        element: <SoportePymesModule />,
        children: [
          ///* preagendamiento soporte pymes
          {
            path: ROUTER_PATHS.soportePymes.preagendamientoNav,
            element: <PreagendamientoSoportePymesPage />,
          },
          {
            path: ROUTER_PATHS.soportePymes.preagendamientoCreate,
            element: <CreateAgendamientoSoportePymesPage />,
          },
          {
            path: ROUTER_PATHS.soportePymes.agendamientoEdit,
            element: <EditAgendamientoSoportePymes />,
          },
        ],
      },
      //////////* Supervisión de Ventas Corporativas ---------------------------
      {
        path: ROUTER_PATHS.ventasCorporativas.root,
        element: <SupervisionVentaCorporativaModule />,
        children: [
          ///* Planes Corporativos
          {
            path: ROUTER_PATHS.ventasCorporativas.planCorporativoNav,
            element: <PlanCoporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.planCorporativoCrearNav,
            element: <CreatePlanCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.planCorporativoEditar,
            element: <EditarPlanCorporativoPage />,
          },

          ///* Solicitudes Pendientes Corporativos
          {
            path: ROUTER_PATHS.ventasCorporativas
              .solicitudesPendientesCorporativoNav,
            element: <SolicitudesPendientesCorporativosPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas
              .solicitudesPendientesCorporativoEdit,
            element: <SolicitudesPendientesCorporativosEdit />,
          },

          ///* Solicitud
          {
            path: ROUTER_PATHS.ventasCorporativas.solicitudCapacidadNav,
            element: <SolicitudesCapacidadCorporativoPage />,
          },

          ///* Solicitud
          {
            path: ROUTER_PATHS.ventasCorporativas.solicitudNuevaLineaNav,
            element: <SolicitudNuevaLineaCorporativoPage />,
          },
        ],
      },
      //////////* Ventas Corporativas ---------------------------
      {
        path: ROUTER_PATHS.ventasCorporativas.root,
        element: <VentaCorporativaModule />,
        children: [
          ///* Planes Corporativos
          // {
          //   path: ROUTER_PATHS.ventasCorporativas.planCorporativoNav,
          //   element: <PlanCoporativoPge />,
          // },
          // {
          //   path: ROUTER_PATHS.ventasCorporativas.planCorporativoCrearNav,
          //   element: <CreatePlanCorporativoPage />,
          // },
          // {
          //   path: ROUTER_PATHS.ventasCorporativas.planCorporativoEditar,
          //   element: <EditarPlanCorporativoPage />,
          // },

          ///* Prospecto corperativos
          {
            path: ROUTER_PATHS.ventasCorporativas.prospectoCrearCorporativo,
            element: <CreateProspectoCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.prospectoEditarCorporativo,
            element: <EditProspectoCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.prospectoCorporativoNav,
            element: <ProspectoCorporativoPage />,
          },

          ///* Preventa corporativo
          {
            path: ROUTER_PATHS.ventasCorporativas.preventaCorporativoNav,
            element: <PreventaCorporativoPage />,
          },
          // {
          //   path: ROUTER_PATHS.ventasCorporativas.preventaCorporativoCrearNav,
          //   element: <CreatePreventaCorporativo />,
          // },

          {
            path: ROUTER_PATHS.ventasCorporativas.preventaCorporativoCrear,
            element: <CreatePreventaCorporativo />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.nPreventaCorporativoCrearNav,
            element: <NPreventaProspectoCorporativa />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.preventaCorporativoCompletar,
            element: <CompletarPreventaCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.preventaCorporativoEdit,
            element: <EditPreventaCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.preventaCorporativoView,
            element: <ViewPreventaCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas
              .solucionCosteadaCorporativoNav,
            element: <SolucionCosteadaPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas
              .solucionCosteadaCorporativoEdit,
            element: <SolucionCosteadaVer />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.estadoVentaCorporativoNav,
            element: <EstadoVentaCorporativoPage />,
          },
          //* Seguimiento y Coste (unificación de Estado Venta + Solución Costeada)
          {
            path: ROUTER_PATHS.ventasCorporativas.seguimientoCosteNav,
            element: <SeguimientoCostePage />,
          },
          //* Gestion Oportunidad Comercial
          {
            path: ROUTER_PATHS.ventasCorporativas
              .gestionOportunidadComercialNav,
            element: <GestionOportunidadComercialPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.oportunidadComercialDemoNav,
            element: <OportunidadComercialTipoPlan />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.coberturaCorporativaNav,
            element: <CoberturaCorporativaPage />,
          },
          {
            path: ROUTER_PATHS.ventasCorporativas.coberturaNapsNav,
            element: <CoberturaNapsPage />,
          },

          ///* Solicitud
          // {
          //   path: ROUTER_PATHS.noc.factibilidadCorporativoNavCrear,
          //   element: <ViewSolicitudVentaCorporativoPage />,
          // }
        ],
      },

      //////////* Noc ---------------------------
      {
        path: ROUTER_PATHS.noc.root,
        element: <NocModule />,
        children: [
          // ===================================================================
          // Factibilidad
          // ===================================================================
          {
            path: ROUTER_PATHS.noc.solicitudVentaCorporativoNav,
            element: <ViewSolicitudVentaCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.factibilidadCorporativoNav,
            element: <FactibilidadCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.factibilidadCorporativoAprobar,
            element: <AprobarSolicitudVentaCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.factibilidadCorporativoNavCrear,
            element: <ViewSolicitudVentaCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.factibilidadCorporativoNavUpdate,
            element: <ViewSolicitudFactibilidadCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.preFactibilidadCorporativoView,
            element: <ViewPreFactibilidadCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.factibilidadCorporativoView,
            element: <ViewFactibilidadCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.trazabilidadFactibilidadCorporativo,
            element: <ViewTrazabilidadFactibilidadPage />,
          },

          ///* Agendamiento NOC
          // ===================================================================
          // Inspección Factibilidad
          // ===================================================================
          {
            path: ROUTER_PATHS.noc.inspeccionCorporativoNav,
            element: <InspeccionFCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.noc.inspeccionCorporativoNavRevisar,
            element: <InspeccionFCorporativoContainer />,
          },
          // ===================================================================
          // Agendamientos
          // ===================================================================
          {
            path: ROUTER_PATHS.noc.agendamientoNocNav,
            element: <AgendamientoNocPage />,
          },

          {
            path: ROUTER_PATHS.noc.createAgendamientoNoc,
            element: <CreateAgendamientoNoc />,
          },

          {
            path: ROUTER_PATHS.noc.reasignarAgendaCorp,
            element: <ReasignarInstlacionAgendaCorporativaPage />,
          },

          ///* solicitud tecnico noc
          {
            path: ROUTER_PATHS.noc.solicitudTecnicoNocNav,
            element: <SolicitudTecnicoNocPage />,
          },
          {
            path: ROUTER_PATHS.noc.solicitudTecnicoNocEditar,
            element: <EditSolicitudTecnicoNocPage />,
          },

          {
            path: ROUTER_PATHS.noc.solicitudTecnicoNocAgendaEditar,
            element: <EditSolicitudTecnicoNocAgendaPage />,
          },
        ],
      },

      // =======================================================================
      // SOPORTE CORPORATIVO
      // =======================================================================
      {
        path: ROUTER_PATHS.soporteCorporativo.root,
        element: <SoporteCorporativoModule />,
        children: [
          {
            path: ROUTER_PATHS.soporteCorporativo.gestionTickets,
            element: <GestionTicketsPage />,
          },
        ],
      },

      // =======================================================================
      // ACTIVACIONES
      // =======================================================================
      {
        path: ROUTER_PATHS.activaciones.root,
        element: <Activaciones />,
        children: [
          // Activaciones
          {
            path: ROUTER_PATHS.activaciones.activacionesInstalacion,
            element: <ActivacionesInstalacionMainPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionInstallPending,
            element: <ActivacionInstallPendingPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionInstallGestionada,
            element: <ActivacionInstallGestionadaPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionInstallCambioPuerto,
            element: <CambiosPendientesOTActivacion />,
          },
          {
            path: ROUTER_PATHS.activaciones
              .activacionInstallCambioPuertoPending,
            element: <ActivacionCambioPuertoPedingPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionInstallFotos,
            element: <FotosInstallActivacionITMainPage />,
          },
          {
            path: ROUTER_PATHS.activaciones
              .activacionPendingRecoordinadaInstallOT,
            element: <ActivacionInstallPendingRecoordinadaOTPage />,
          },
          // Activaciones rechazadas Tecnico
          {
            path: ROUTER_PATHS.activaciones.activacionRechazadasTecnicoNav,
            element: <RechazadasTecnicoPEPage />,
          },

          // Puertos Disponibles
          {
            path: ROUTER_PATHS.activaciones.activacionCajasPuertosDisponibles,
            element: <PuertosDisponiblesPage />,
          },
          {
            path: ROUTER_PATHS.activaciones
              .activacionCajasPuertosDisponiblesRevisar,
            element: <RevisarPuertosDisponiblesPage />,
          },

          // Actualizar Servicio de Cliente
          {
            path: ROUTER_PATHS.activaciones.activacionActServicioClientesNav,
            element: <ActualizarServicioClientePageMain />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionActServicioClientesCrear,
            element: <NewServicioClientePage />,
          },
          {
            path: ROUTER_PATHS.activaciones
              .activacionActServicioClientesActualizar,
            element: <UpdateServicioClientePage />,
          },
          // ===================================================================
          // RAD CHECK
          // ===================================================================
          {
            path: ROUTER_PATHS.activaciones.activacionRadCheck,
            element: <RadCheckPageMain />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionRadCheckCrear,
            element: <CreateRadCheckPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionRadCheckCrear,
            element: <CreateRadCheckPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionRadCheckActualizar,
            element: <UpdateRadCheckPage />,
          },

          // Activaciones corporativos
          {
            path: ROUTER_PATHS.activaciones.tecnicosInstalacionCorp,
            element: <InstalacionCorporativosPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.tecnicosInstalacionActivarCorp,
            element: <UpdateInstalacionCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionesVisitaNav,
            element: <ActivacionesVisitaMainPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionVisitaPending,
            element: <ActivacionesVisitaPendingPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionVisitaGestionada,
            element: <ActivacionesVisitaGestionadaPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionesTrasladoNav,
            element: <ActivacionesTrasladoMainPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionTrasladoPending,
            element: <ActivacionTrasladoPendingPage />,
          },
          {
            path: ROUTER_PATHS.activaciones
              .activacionTrasladoPendingRecoordinada,
            element: <ActivacionTrasladoPendingPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionTrasladoGestionada,
            element: <ActivacionTrasladoGestionadaPage />,
          },
          {
            path: ROUTER_PATHS.activaciones.activacionesConsultasNav,
            element: <ReporteConsultasPorTipoPage />,
          },
        ],
      },

      //////////* Operaciones PyL ---------------------------
      {
        path: ROUTER_PATHS.operaciones.root,
        element: <AdministracionModule />,
        children: [
          {
            path: ROUTER_PATHS.operaciones.agendamientoPyL,
            element: <AgendamientosPagePyL />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendamientoPyLConfirmar,
            element: <UpdatePreagendamientoPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendamientoReasignar,
            element: <UpdateAgendamientoPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendamientoRecoordinar,
            element: <AgendaRecoordinacionPyLPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendamientosRevisarUpdated,
            element: <ReviewPreagendaUpdatedPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendamientoPyLFinalizados,
            element: <AgendamientosFinalizadosPyL />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendamientoPyLReporte,
            element: <ReporteAgendamientosPylPage />,
          },

          // Técnico
          {
            path: ROUTER_PATHS.operaciones.tecnicosInstalacion,
            element: <OperacionTecnicoInstallMainPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.tecnicoPrerechazada,
            element: <OperacionReviewOTInstallPRerechazada />,
          },

          // Auditoria
          {
            path: ROUTER_PATHS.operaciones.auditoriaInstalaciones,
            element: <AuditoriaInstalacionesOTMainPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.auditoriaInstalacionesRealizadas,
            element: <ViewOTInstallRealizadaAuditoriaPage />,
          },
          /// bitacora
          {
            path: ROUTER_PATHS.operaciones.bitacoraPylNav,
            element: <BitacoraPylPage />,
          },
          /// bitacora
          {
            path: ROUTER_PATHS.operaciones.rechazadasTecnicoNav,
            element: <RechazadasTecnicoPEPage />,
          },

          /// Informe de Instalaciones Programadas y Resultados Diarios
          {
            path: ROUTER_PATHS.operaciones.InformeInstalacionPylNav,
            element: <InformeInstalacionProgramadasPagePyl />,
          },

          // Agenda de Flotas
          {
            path: ROUTER_PATHS.operaciones.flotasViewNav,
            element: <PlanificadoresPageView />,
          },
          {
            path: ROUTER_PATHS.operaciones.agendaFlota,
            element: <PlanificadorCalendarViewPage />,
          },

          // Seguimiento de actividades
          {
            path: ROUTER_PATHS.operaciones.agendamientoPyLSeguimientoNav,
            element: <SeguimientodeActividadesPyL />,
          },

          /// orden de servicio
          {
            path: ROUTER_PATHS.operaciones.trasladosPyLNav,
            element: <OrdenServicioTrasladoPage />,
          },

          /// orden de servicio - vista general filtrable
          {
            path: ROUTER_PATHS.operaciones.ordenesServicioGeneralNav,
            element: <OrdenServicioGeneralPage />,
          },

          {
            path: ROUTER_PATHS.operaciones.trasladosAgendamientoPyL,
            element: <OrdenServicioAgendamientoPage />,
          },
          //orden servicio - visita
          {
            path: ROUTER_PATHS.operaciones.visitasPylNav,
            element: <OrdenServicioVisitaPage />,
          },
          {
            path: ROUTER_PATHS.operaciones.visitasAgendamientoPyl,
            element: <OrdenServicioVisitaAgendamientoPage />,
          },
        ],
      },

      //////////* Técnico ---------------------------
      {
        path: ROUTER_PATHS.tecnico.root,
        element: <TecnicoModule />,
        children: [
          {
            path: ROUTER_PATHS.tecnico.ordenenTrabajoNav,
            element: <InstalacionesTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.ordenenTrabajoAsignadas,
            element: <InstalacionAsignadaTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.ordenTrabajoAsigRecoordinada,
            element: <InstalacionRecoordinadaTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.ordenTrabajoPendienteActualizar,
            element: <InstalacionActualizarTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.ordenTrabajoRevisionRealizadas,
            element: <InstalacionRevisarOTPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.ordenTrabajoFotos,
            element: <FotosInstallTecnicoOTMainPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.visitas,
            element: <VisitasTecnico />,
          },
          {
            path: ROUTER_PATHS.tecnico.retiros,
            element: <RetirosTecnico />,
          },
          {
            path: ROUTER_PATHS.tecnico.traslados,
            element: <TrasladosTecnico />,
          },
          {
            path: ROUTER_PATHS.tecnico.migraciones,
            element: <MigracionesTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.ordenesNocNav,
            element: <OrdenesNocTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.servicioCorporativo,
            element: <OrdenServicioCorporativoPage />,
          },

          ///* Orden de trabajo Corporativo
          {
            path: ROUTER_PATHS.tecnico.ordenenTrabajoAsignadasCorp,
            element: <InstalacionAsignadaTecnicoCorporativoPage />,
          },

          ///* ATS
          {
            path: ROUTER_PATHS.tecnico.atsNav,
            element: <ATSMainPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.atsIdNav,
            element: <ATSContainerPage />,
          },
          ///* Cuadre
          {
            path: ROUTER_PATHS.tecnico.cuadreNav,
            element: <CuadreTecnicoPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.notificacionInventarioNav,
            element: <NotificacionInventarioPage />,
          },
          {
            path: ROUTER_PATHS.tecnico.consultasNapsNav,
            element: <ReporteConsultasPorNapPage />,
          },
        ],
      },

      //////////* Clientes ---------------------------
      {
        path: ROUTER_PATHS.clientes.root,
        element: <ClientesModule />,
        children: [
          //Actualizar Cliente
          {
            path: ROUTER_PATHS.clientes.actualizarDataCliente,
            element: <ClienteUpdateDataPage />,
          },

          //Contrato
          // {
          //   path: ROUTER_PATHS.clientes.clienteContratoNav,
          //   element: <ContratoPage />,
          // },
          //Fibra
          {
            path: ROUTER_PATHS.clientes.fibraOpticaNav,
            element: <ClientesFibraMainPage />,
          },
          {
            path: ROUTER_PATHS.clientes.fibraOpticaView,
            element: <ClienteFibraPage />,
          },
          //Wireless
          {
            path: ROUTER_PATHS.clientes.wirelessNav,
            element: <ClientesWirelessMainPage />,
          },
          {
            path: ROUTER_PATHS.clientes.wirelessView,
            element: <ClienteWirelessPage />,
          },
          //Corporativo
          {
            path: ROUTER_PATHS.clientes.corporativoNav,
            element: <ClientesCorporativosMainPage />,
          },
          {
            path: ROUTER_PATHS.clientes.corporativoView,
            element: <ClienteCorporativoPage />,
          },

          ///* cliente pymes

          {
            path: ROUTER_PATHS.clientes.clientesPymesNav,
            element: <ClientesPymesPage />,
          },
          {
            path: ROUTER_PATHS.clientes.solicitudContratoPymes,
            element: <SolicitudContratoClientePymes />,
          },

          ///* clientes bras

          {
            path: ROUTER_PATHS.clientes.clientesBrasNav,
            element: <ClientesBrasPage />,
          },
        ],
      },

      //////////* Mantenimiento y Operaciones ---------------------------
      {
        path: ROUTER_PATHS.mantenimientoOperaciones.root,
        element: <MantenimientoOperacionModule />,
        children: [
          ///* Zonas ----------
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.zonas,
            element: <ZonesPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.zonasCrear,
            element: <CreateZonePage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.zonasEditar,
            element: <UpdateZonePage />,
          },

          ///* Sectores ----------
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.sectores,
            element: <SectorsPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.sectoresCrear,
            element: <CreateSectorPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.sectoresEditar,
            element: <UpdateSectorPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.nodos,
            element: <NodoPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.nodosCrear,
            element: <CreateNodoPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.nodosEditar,
            element: <UpdateNodoPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.radioBases,
            element: <RadioBasesPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.radioBasesEditar,
            element: <UpdateRadioBasePage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.radioBasesCrear,
            element: <CreateRadioBasePage />,
          },
          // ===================================================================
          // NAPS EN MÓDULO DE MANTENIMIENTO DEPRECADAS
          // ===================================================================
          // {
          //   path: ROUTER_PATHS.mantenimientoOperaciones.naps,
          //   element: <NapsPage />,
          // },
          // {
          //   path: ROUTER_PATHS.mantenimientoOperaciones.napsCrear,
          //   element: <CreateNapsPage />,
          // },
          // {
          //   path: ROUTER_PATHS.mantenimientoOperaciones.napsEditar,
          //   element: <UpdateNapsPage />,
          // },

          {
            path: ROUTER_PATHS.mantenimientoOperaciones.planificador,
            element: <PlanificadoresPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.planificadorCrear,
            element: <CreatePlanificador />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.planificadorHorario,
            element: <PlanificadorCalendarPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.flota,
            element: <FlotasPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.flotaCrear,
            element: <CreateFlotaPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.flotaEditar,
            element: <UpdateFlotaPage />,
          },

          ///* Pendiente actualizar operaciones
          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .pendienteActualizarOperacionesNav,
            element: <PendienteActualizarOperacion />,
          },

          ///* Pendiente actualizar operaciones
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.rechazadasTecnicoNav,
            element: <RechazadasTecnicoPEPage />,
          },
          ///* Solicitu técnico para ventas pymes
          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .solicitudTecnicoPymesNav,
            element: <SolicitudTecnicoPlantaExternaPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .solicitudTecnicoPymesEditar,
            element: <EditSolicitudTecnicoPlantaExternaPage />,
          },

          ///* solicitud tecnico
          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .solicitudTecnicoPymesNav,
            element: <SolicitudTecnicoPlantaExternaPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .solicitudTecnicoPymesEditar,
            element: <EditSolicitudTecnicoPlantaExternaPage />,
          },

          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .solicitudTecnicoPymesAgendaEditar,
            element: <EditSolicitudTecnicoPlantaExternaAgendaPage />,
          },

          ///* Instalaciones tecnicos
          {
            path: ROUTER_PATHS.mantenimientoOperaciones
              .instalacionesTecnicosNav,
            element: <InstalacionesTecnicosPage />,
          },
          {
            path: ROUTER_PATHS.mantenimientoOperaciones.instalacionesTecnicos,
            element: <CheckInstalacionTecnicoPage />,
          },
        ],
      },

      //////////* Configuración RED ---------------------------
      {
        path: ROUTER_PATHS.configuracionRED.root,
        element: <AdministracionModule />,
        children: [
          ///* Grupo IPv4 ----------
          {
            path: ROUTER_PATHS.configuracionRED.grupoIpv4,
            element: <Ipv4GroupsPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.grupoIpv4Crear,
            element: <CreateIpv4Group />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.grupoIpv4Editar,
            element: <UpdateIpv4Group />,
          },

          ///* Grupo IPv6 ----------
          {
            path: ROUTER_PATHS.configuracionRED.grupoIpv6,
            element: <Ipv6GroupsPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.grupoIpv6Crear,
            element: <CreateIpv6GroupPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.grupoIpv6Editar,
            element: <UpdateIpv6GroupPage />,
          },

          ///* IPv4 ----------
          {
            path: ROUTER_PATHS.configuracionRED.ipv4Nav,
            element: <IPV4Page />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.ipv4CrearNav,
            element: <CreateIPV4Page />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.ipv4Editar,
            element: <UpdateIPV4Page />,
          },

          ///* OLT ----------
          {
            path: ROUTER_PATHS.configuracionRED.olt,
            element: <OLTsPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.oltCrear,
            element: <CreateOltPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.oltEditar,
            element: <UpdateOltPage />,
          },
          ///* Nodo ----------
          {
            path: ROUTER_PATHS.configuracionRED.nodo,
            element: <NodoPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.nodoCrear,
            element: <CreateNodoPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.nodoEditar,
            element: <UpdateNodoPage />,
          },
          ///* Caja Primaria / Manga ----------
          {
            path: ROUTER_PATHS.configuracionRED.cajaPrimaria,
            element: <CajaPrimariaPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.cajaPrimariaCrear,
            element: <CreateCajaPrimariaPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.cajaPrimariaEditar,
            element: <UpdateCajaPrimariaPage />,
          },
          // ===================================================================
          // Caja secundaria pasa a ser la nap
          // ===================================================================
          {
            path: ROUTER_PATHS.configuracionRED.naps,
            element: <NapsPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.napsCrear,
            element: <CreateNapsPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.napsEditar,
            element: <UpdateNapsPage />,
          },

          ///* Router ----------
          {
            path: ROUTER_PATHS.configuracionRED.routers,
            element: <RoutesrPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.routersCrear,
            element: <CreateRouterPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.routersEditar,
            element: <UpdateRouterPage />,
          },

          ///* Bras ---------
          {
            path: ROUTER_PATHS.configuracionRED.brasNav,
            element: <BrasPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.brasCrearNav,
            element: <CreateBrasPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.brasEditar,
            element: <UpdateBrasPage />,
          },

          ///* Radius ---------
          {
            path: ROUTER_PATHS.configuracionRED.radiusNav,
            element: <RadiusPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.radiusCrearNav,
            element: <CreateRadiusPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.radiusEditar,
            element: <UpdateRadiusPage />,
          },

          ///* Operadora ---------
          {
            path: ROUTER_PATHS.configuracionRED.operadoraNav,
            element: <OperadoraPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.operadoraCrearNav,
            element: <CreateOperadoraPage />,
          },
          {
            path: ROUTER_PATHS.configuracionRED.operadoraEditar,
            element: <UpdateOperadoraPage />,
          },
          ///* Migraciones Radius ---------
          {
            path: ROUTER_PATHS.configuracionRED.radiusMigracionesNav,
            element: <RadiusMigracionesPage />,
          },
          ///* Service Profile ---------
          {
            path: ROUTER_PATHS.configuracionRED.serviceProfileNav,
            element: <ServiceProfilePage />,
          },
          // {
          //   path: ROUTER_PATHS.configuracionRED.serviceProfileCrearNav,
          //   element: <CreateServiceProfilePage />,
          // },
          {
            path: ROUTER_PATHS.configuracionRED.serviceProfileEditar,
            element: <UpdateServiceProfilePage />,
          },
        ],
      },
      //inventario
      {
        path: ROUTER_PATHS.inventario.root,
        element: <InventarioModule />,
        children: [
          //Producto
          {
            path: ROUTER_PATHS.inventario.productosNav,
            element: <ProductoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.productosCrearNav,
            element: <CreateInventariablePage />,
          },
          {
            path: ROUTER_PATHS.inventario.productosEditarIdNav,
            element: <UpdateInventarioPage />,
          },

          //Ingreso de inventario
          {
            path: ROUTER_PATHS.inventario.ingresoInventario,
            element: <InventarioManual />,
          },

          {
            path: ROUTER_PATHS.inventario.ingresoHistorial,
            element: <IngresoInventarioHistorialPage />,
          },

          //Solicitud de tralado
          {
            path: ROUTER_PATHS.inventario.solicitudInventarioNav,
            element: <SolicitudTransferenciaInventarioPage />,
          },

          {
            path: ROUTER_PATHS.inventario.solicitudInventarioCrearNav,
            element: <SolicitudTransferenciaInventarioCreatePage />,
          },

          //Revision de solicitud de traslado para inventario
          {
            path: ROUTER_PATHS.inventario.revisarSolicitudInventarioNav,
            element: <RevisionSolicitudTransferenciaInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.revisarSolicitudInventarioCrearNav,
            element: <RevisionSolicitudTransferenciaInventarioAccionPage />,
          },

          //Traslado de inventario
          {
            path: ROUTER_PATHS.inventario.trasladoInventario,
            element: <TransferenciaInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.trasladoInventarioSolicitudEgresoNav,
            element: <TrasladoInventarioCrearPage />,
          },
          {
            path: ROUTER_PATHS.inventario
              .transferenciaInventarioSolicitudEgresoNav,
            element: <TransferenciaInventarioPedidoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.trasladoInventarioIngresoNav,
            element: <CreateTrasladoInventarioIngresoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.trasladoInventarioAccionNav,
            element: <TrasladoInventarioAccionPage />,
          },
          {
            path: ROUTER_PATHS.inventario.trasladoInventarioEdit,
            element: <EditTransferenciaInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario
              .trasladoInventarioCreateNotificacionNav,
            element: <CreateNotificacionTrasladoPage />,
          },

          // Recepcion de transferencia de inventario
          {
            path: ROUTER_PATHS.inventario.recepcionTransferenciaInventarioNav,
            element: <TransitoTransferenciaInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.recepcionEditTransferenciaInventario,
            element: <EditRevisionTransferenciaInventarioPage />,
          },

          //Kardex
          {
            path: ROUTER_PATHS.inventario.kardexNav,
            element: <KardexPage />,
          },

          //Modelo Producto

          {
            path: ROUTER_PATHS.inventario.modelo_productos,
            element: <ModelosProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.modelo_productos_crear,
            element: <CreateModeloProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.modelo_productos_editar,
            element: <UpdateModeloProductoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos,
            element: <CategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos_crear,
            element: <CreateCategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos_editar,
            element: <UpdateCategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.marca_productos,
            element: <MarcasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.marca_productos_crear,
            element: <CreateMarcaProductoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.marca_productos_editar,
            element: <UpdateMarcasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.subcategoria_productos,
            element: <SubcategoriasPage />,
          },
          {
            path: ROUTER_PATHS.inventario.subcategoria_productos_crear,
            element: <CreateSubcategoriasPage />,
          },
          {
            path: ROUTER_PATHS.inventario.subcategoria_productos_editar,
            element: <UpdateSubcategoriasPage />,
          },
          {
            path: ROUTER_PATHS.inventario.bodegas,
            element: <BodegasPage />,
          },
          {
            path: ROUTER_PATHS.inventario.bodegas_crear,
            element: <CreateBodegasPage />,
          },
          {
            path: ROUTER_PATHS.inventario.bodegas_editar,
            element: <UpdateBodegasPage />,
          },
          {
            path: ROUTER_PATHS.inventario.ubicacion,
            element: <UbicacionesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.ubicacion_crear,
            element: <CreateUbicacionesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.ubicacion_editar,
            element: <UpdateUbicacionesPage />,
          },
          ///pedido
          {
            path: ROUTER_PATHS.inventario.solicitud_pedido,
            element: <SolicitudUsuariosPedidosPagina />,
          },
          {
            path: ROUTER_PATHS.inventario.solicitud_all_action,
            element: <SolicitudPrevPedidosPagina />,
          },
          {
            path: ROUTER_PATHS.inventario.solicitud_pedido_revision_nav,
            element: <RevisionSolicitudPedido />,
          },
          {
            path: ROUTER_PATHS.inventario.gastos,
            element: <GastosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.gastos_crear,
            element: <CreateGastosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.gastos_editar,
            element: <UpdateGastosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.egresos,
            element: <EgresoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.egresos_crear,
            element: <CreateEgresoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.egresos_action_nav,
            element: <CreateEgresoPage />,
          },

          {
            path: ROUTER_PATHS.inventario.costos,
            element: <CostosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.costos_crear,
            element: <CreateCostosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.costos_editar,
            element: <UpdateCostosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.marca_productos,
            element: <MarcasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.marca_productos_crear,
            element: <CreateMarcaProductoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.marca_productos_editar,
            element: <UpdateMarcasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos,
            element: <CategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos_crear,
            element: <CreateCategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos_editar,
            element: <UpdateCategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.presentacion,
            element: <PresentacionPage />,
          },
          {
            path: ROUTER_PATHS.inventario.presentacion_crear,
            element: <CreatePresentacionesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.presentacion_editar,
            element: <UpdatePresentacionesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.medidas_productos,
            element: <MedidasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.medidas_productos_crear,
            element: <CreateMedidasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.medidas_productos_editar,
            element: <UpdateMedidasProductoPage />,
          },

          {
            path: ROUTER_PATHS.inventario.categoria_productos_crear,
            element: <CreateCategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.categoria_productos_editar,
            element: <UpdateCategoryProductPage />,
          },
          {
            path: ROUTER_PATHS.inventario.presentacion,
            element: <PresentacionPage />,
          },
          {
            path: ROUTER_PATHS.inventario.presentacion_crear,
            element: <CreatePresentacionesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.presentacion_editar,
            element: <UpdatePresentacionesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.medidas_productos,
            element: <MedidasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.medidas_productos_crear,
            element: <CreateMedidasProductosPage />,
          },
          {
            path: ROUTER_PATHS.inventario.medidas_productos_editar,
            element: <UpdateMedidasProductoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.solicitud_ingreso_inventario,
            element: <SolicitudIngresoBodegaPagina />,
          },
          {
            path: ROUTER_PATHS.inventario.solicitud_ingreso_bodega,
            element: <SolicitudIngresoBodegaPagina />,
          },
          //*Solicitud de compra/ingreso
          {
            path: ROUTER_PATHS.inventario.solicitud_ingreso_compraNav,
            element: <SolicitudIngresoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.solicitud_ingreso_compraCrear,
            element: <CrearSolicitudIngresoPage />,
          },
          {
            path: ROUTER_PATHS.inventario.solicitud_ingreso_compraEditar,
            element: <EditSolicitudIngresoPage />,
          },
          //*recepcion
          {
            path: ROUTER_PATHS.inventario.recepcionCompraNav,
            element: <RecepcionCompraPage />,
          },
          {
            path: ROUTER_PATHS.inventario.recepcionCompraCrear,
            element: <RecepcionCompraCrearPage />,
          },
          /* {
            path: ROUTER_PATHS.inventario.recepcionCompraCrearNav,
            element: <CreateRecepcionCompraPage />,
          }, */

          ///* kit

          {
            path: ROUTER_PATHS.inventario.kitInventariable,
            element: <KitInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.kitInventariableCreateNav,
            element: <KitInventarioCreate />,
          },
          ///* Solicitud de factibilidad corporativo
          {
            path: ROUTER_PATHS.inventario.solicitudFactibilidadCorporativoNav,
            element: <SolicitudFactibilidadCorporativoPage />,
          },
          {
            path: ROUTER_PATHS.inventario
              .revisarSolicitudFactibilidadCorporativo,
            element: <CreateInventarioSolicitudFactibilidadPage />,
          },
          {
            path: ROUTER_PATHS.inventario.kitInventariableEditNav,
            element: <KitInventarioEditPage />,
          },

          ///* Toma fisica
          {
            path: ROUTER_PATHS.inventario.tomaFisicaCrearNav,
            element: <CreateTomaFisicaPage />,
          },
          {
            path: ROUTER_PATHS.inventario.tomaFisicaEditar,
            element: <EditTomaFisicaPage />,
          },
          {
            path: ROUTER_PATHS.inventario.tomaFisicaHistorialNav,
            element: <TomaFisicaPage />,
          },

          ///* Reporte de stock
          {
            path: ROUTER_PATHS.inventario.reporteStockNav,
            element: <ReporteStockPage />,
          },

          ///* Servicio

          {
            path: ROUTER_PATHS.inventario.servicio,
            element: <ProductoServicioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.servicioCreateNav,
            element: <CreateProductoServicioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.servicioEditar,
            element: <UpdateProductoServicioPage />,
          },

          ///* Cuadre inventario
          {
            path: ROUTER_PATHS.inventario.cuadreInventarioNav,
            element: <CuadreInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.cuadreInventarioCrearNav,
            element: <CreateCuadreInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.cuadreInventarioEditar,
            element: <EditCuadreInventarioPage />,
          },
          {
            path: ROUTER_PATHS.inventario.generador_series,
            element: <GeneradorSeriesPage />,
          },
          {
            path: ROUTER_PATHS.inventario.configuracion_transito,
            element: <ConfiguracionTransitoPage />,
          },
        ],
      },
      //pedidos
      {
        path: ROUTER_PATHS.pedidos.root,
        element: <ComprasModule />,
        children: [
          {
            path: ROUTER_PATHS.pedidos.solicitud_pedidos,
            element: <SolicitudPedidosPagina />,
          },
          {
            path: ROUTER_PATHS.pedidos.solicitud_pedidos_crear,
            element: <CreateSolicitudesPedidosPage />,
          },
          {
            path: ROUTER_PATHS.pedidos.solicitud_pedidos_editar,
            element: <EditarSolicitudPedido />,
          },
        ],
      },
      //compras
      {
        path: ROUTER_PATHS.compras.root,
        element: <ComprasModule />,
        children: [
          {
            path: ROUTER_PATHS.compras.proveedores,
            element: <ProveedorPage />,
          },
          {
            path: ROUTER_PATHS.compras.proveedores,
            element: <ProveedorPage />,
          },
          {
            path: ROUTER_PATHS.compras.proveedores_crear,
            element: <CreateProveedoresPage />,
          },
          {
            path: ROUTER_PATHS.compras.proveedores_editar,
            element: <UpdateProveedorPage />,
          },
          {
            path: ROUTER_PATHS.compras.retencion_compra,
            element: <RetencionesPage />,
          },
          {
            path: ROUTER_PATHS.compras.retencion_compra_crear,
            element: <CreateRetencionPage />,
          },
          {
            path: ROUTER_PATHS.compras.retencion_compra_editar,
            element: <UpdateRetencionesPage />,
          },
          {
            path: ROUTER_PATHS.compras.tipo_compras,
            element: <TiposComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.tipo_compras_crear,
            element: <CreateTypeComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.tipo_compras_editar,
            element: <UpdateTypeComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.orden_compras,
            element: <OrdenComprasPagina />,
          },
          {
            path: ROUTER_PATHS.compras.orden_compras_crear,
            element: <CreateOrdenesComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.orden_compras_editar,
            element: <EditarordenCompra />,
          },
          {
            path: ROUTER_PATHS.compras.orden_compras_action_nav,
            element: <CreateOrdenesComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.grupo_proveedores,
            element: <GroupProovedoresPage />,
          },
          {
            path: ROUTER_PATHS.compras.grupo_proveedores_crear,
            element: <CreateGroupProveedorPage />,
          },
          {
            path: ROUTER_PATHS.compras.grupo_proveedores_editar,
            element: <UpdateGroupProveedorPage />,
          },
          {
            path: ROUTER_PATHS.compras.solicitud_pedidos,
            element: <SolicitudPedidosPagina />,
          },
          {
            path: ROUTER_PATHS.compras.solicitud_pedidos_crear,
            element: <CreateSolicitudesPedidosPage />,
          },
          //** revision solicitud compra
          {
            path: ROUTER_PATHS.compras.solicitud_ingreso_revision_nav,
            element: <RevisionSolicitudIngresoPagina />,
          },
          {
            path: ROUTER_PATHS.compras.solicitud_ingreso_revision_nav,
            element: <RevisionSolicitudIngresoPagina />,
          },
          // {
          //   path: ROUTER_PATHS.compras.solicitud_ingreso,
          //   element: <SolicitudIngresoPagina />,
          // },
          {
            path: ROUTER_PATHS.compras.solicitud_ingreso_crear,
            element: <SaveSolicitudesIngreso />,
          },
          {
            path: ROUTER_PATHS.compras.solicitud_ingreso_revision_editar,
            element: <RevisionSolicitudIngresoEditar />,
          },
          //*orden compra
          {
            path: ROUTER_PATHS.compras.solicitud_ingreso_nav,
            element: <CreateOrdenesComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.orden_compras_revision,
            element: <RevisionOrdenesComprasPage />,
          },
          {
            path: ROUTER_PATHS.compras.orden_compras_finalizar_nav,
            element: <FinalizarOrdenesCompraAbierto />,
            //element:<FinalizarOrdenesCompraAbiertaPage/>
          },
          {
            path: ROUTER_PATHS.compras.orden_compras_consulta_nav,
            element: <ConsultaOrdenCompraPage />,
          },
          {
            path: ROUTER_PATHS.compras.reporte_compra,
            element: <ViewReporteCompraPage />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.nomina.root,
        element: <EmpleadosModule />,
        children: [
          {
            path: ROUTER_PATHS.nomina.cargos,
            element: <CargosPage />,
          },
          {
            path: ROUTER_PATHS.nomina.cargos_crear,
            element: <CreateCargosPage />,
          },
          {
            path: ROUTER_PATHS.nomina.cargos_editar,
            element: <UpdateCargoPage />,
          },
          {
            path: ROUTER_PATHS.nomina.empleados,
            element: <EmpleadosPage />,
          },
          {
            path: ROUTER_PATHS.nomina.empleados_crear,
            element: <CreateEmpleadosPage />,
          },
          {
            path: ROUTER_PATHS.nomina.empleados_editar,
            element: <UpdateEmpleadoPage />,
          },
        ],
      },

      //////////* Soporte Técnico ---------------------------
      {
        path: ROUTER_PATHS.soporteTecnico.root,
        element: <TechnicalSupportModule />,
        children: [
          {
            path: ROUTER_PATHS.soporteTecnico.desbloqueoUsuarioNav,
            element: <BlockedUsersPassWrongPage />,
          },
        ],
      },

      //////////*TICKETS SOPORTE CLIENTE ---------------------------
      {
        path: ROUTER_PATHS.ticketSoporteCliente.root,
        element: <TicketClientesModule />,
        children: [
          // ===================================================================
          // Nuevo Ticket
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_nav,
            element: <NuevoTicketPage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_crear,
            element: <CreateNuevoTicketPage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.nuevo_ticket_editar,
            element: <UpdateNuevoTicket />,
          },
          // ===================================================================
          // Categoría Incidente
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.categoria_incidente_nav,
            element: <CategoriaIncidentePage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.categoria_incidente_crear,
            element: <CrearCategoriaIncidentePage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.categoria_incidente_editar,
            element: <ActCategoriaIncidentePage />,
          },
          // ===================================================================
          // SubCategoría Incidente
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.subcategoria_incidente_nav,
            element: <SubcategoriaIncidentePage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente
              .subcategoria_incidente_crear,
            element: <CrearSubcategoriaIncidente />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente
              .subcategoria_incidente_editar,
            element: <ActSubcategoriaIncidente />,
          },
          // ===================================================================
          // Causal Incidente
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.causal_incidente_nav,
            element: <CausalIncidentePage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.causal_incidente_crear,
            element: <CrearCausalIncidentePage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.causal_incidente_editar,
            element: <ActCausalIncidentePage />,
          },
          //************MIS TICKETS**************/
          {
            path: ROUTER_PATHS.ticketSoporteCliente.mis_tickets_nav,
            element: <TicketPage />,
          },
          // ===================================================================
          // Detalle Ticket
          // ===================================================================
          {
            path:
              ROUTER_PATHS.ticketSoporteCliente.detalle_ticket_nav +
              "/:ticketId",
            element: <DetalleTicketPage />,
          },
          // ===================================================================
          // Editar Ticket
          // ===================================================================
          {
            path:
              ROUTER_PATHS.ticketSoporteCliente.editar_ticket_nav +
              "/:ticketId",
            element: <EditarTicketPage />,
          },
          // ===================================================================
          // Perfil Cliente
          // ===================================================================
          {
            path:
              ROUTER_PATHS.ticketSoporteCliente.perfil_cliente_nav +
              "/:clienteId",
            element: <PerfilClientePage />,
          },
          // ===================================================================
          // Masivos
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.masivos_nav,
            element: <MasivosPage />,
          },
          {
            path: ROUTER_PATHS.ticketSoporteCliente.masivos_crear_nav,
            element: <CrearMasivoPage />,
          },
          {
            path:
              ROUTER_PATHS.ticketSoporteCliente.masivo_detalle_nav +
              "/:masivoId",
            element: <DetalleMasivoPage />,
          },
          // ===================================================================
          // Agenda Tecnicos
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.agenda_nav,
            element: <AgendaPage />,
          },
          // ===================================================================
          // Catalogos
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.catalogos_nav,
            element: <CatalogosPage />,
          },
          // ===================================================================
          // Migracion Softnet
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.migracion_softnet_nav,
            element: <MigracionSoftnetPage />,
          },
          // ===================================================================
          // Dashboard Supervisor (gated por permiso tickets.ver_dashboard_supervisor
          // en el componente; el backend tambien valida con @PreAuthorize)
          // ===================================================================
          {
            path: ROUTER_PATHS.ticketSoporteCliente.dashboard_nav,
            element: <DashboardSupervisorPage />,
          },
          // Gestion de Accesos movido a /parametrizacion/gestion-accesos

          // Tickets Internos se gestionan en las bandejas existentes (mis-tickets)
        ],
      },
      ////////VISITAS
      {
        path: ROUTER_PATHS.visitas.root,
        element: <VisitaModule />,
        children: [
          {
            path: ROUTER_PATHS.visitas.ticket_nav,
            element: <TicketPendientesAsignacionPage />,
          },
          {
            path: ROUTER_PATHS.visitas.agenda_diaria_nav,
            element: <AgendaVisitaDiariaPage />,
          },
        ],
      },
      //////////*Contabilidad
      {
        path: ROUTER_PATHS.contabilidad.root,
        element: <ContabilidadModule />,
        children: [
          {
            path: ROUTER_PATHS.contabilidad.revisionVoucherNav,
            element: <RevisionVoucherPage />,
          },
          {
            path: ROUTER_PATHS.contabilidad.revisionVoucherAccion,
            element: <VoucherAccionPage />,
          },
          {
            path: ROUTER_PATHS.contabilidad.planCuentaNav,
            element: <PlanCuentaPage />,
          },

          // Clientes Corporativos ------
          {
            path: ROUTER_PATHS.contabilidad.clientesCoorporativosNav,
            element: <ClientesCoorporativosPage />,
          },
          {
            path: ROUTER_PATHS.contabilidad.clientesCoorporativosAccion,
            element: <ClientesCoorporativosLoader />,
            // element: <ClientesCoorporativosPage />,
          },
          {
            path: ROUTER_PATHS.contabilidad.clientesCoorporativosAccion,
            element: <ClientesCoorporativosSave />,
          },

          //registro de factura
          {
            path: ROUTER_PATHS.contabilidad.registroFacturaNav,
            //element: <RegistroFacturaPage />,
            element: <RegistrFacturas />,
          },
          {
            path: ROUTER_PATHS.contabilidad.registroFacturaNavCrear,
            element: <CreateregistroFacturas />,
            //element: <RegistroFacturaSave />,
          },
          {
            path: ROUTER_PATHS.contabilidad.gestionInventarioCuadreNav,
            element: <GestionInventarioCuadrePage />,
          },

          {
            path: ROUTER_PATHS.contabilidad.reingresoSerieNav,
            element: <ReingresoSeriePage />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.servicioInternet.root,
        element: <ServicionsModule />,
        children: [
          {
            path: ROUTER_PATHS.servicioInternet.planes,
            element: <PlansPage />,
          },
          {
            path: ROUTER_PATHS.servicioInternet.planesCrear,
            element: <CreatePlanPage />,
          },
          {
            path: ROUTER_PATHS.servicioInternet.planesEditar,
            element: <UpdatePlanPage />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.activos.root,
        element: <ActivosModule />,
        children: [
          {
            path: ROUTER_PATHS.activos.activos,
            element: <ActivosPage />,
          },
          {
            path: ROUTER_PATHS.activos.activos_crear,
            element: <CreateActivosPage />,
          },
          {
            path: ROUTER_PATHS.activos.activos_editar,
            element: <UpdateActivosPage />,
          },
          {
            path: ROUTER_PATHS.activos.responsables_crear,
            element: <CreateResponsablePage />,
          },
          {
            path: ROUTER_PATHS.activos.grupo_activos,
            element: <GrupoActivosPage />,
          },
          {
            path: ROUTER_PATHS.activos.grupo_activos_crear,
            element: <CreateGrupoActivosPage />,
          },
          {
            path: ROUTER_PATHS.activos.grupo_activos_editar,
            element: <UpdateGrupoActivosPage />,
          },
          {
            path: ROUTER_PATHS.activos.responsables_editar,
            element: <UpdateResponsablePage />,
          },
          {
            path: ROUTER_PATHS.activos.mantenimiento,
            element: <MantenimientoPage />,
          },
          {
            path: ROUTER_PATHS.activos.mantenimiento_crear,
            element: <CreateMantenimientoPage />,
          },
          {
            path: ROUTER_PATHS.activos.mantenimiento_editar,
            element: <UpdateMantenimientoPage />,
          },
          {
            path: ROUTER_PATHS.activos.asignaciones,
            element: <AsignacionesPage />,
          },
          {
            path: ROUTER_PATHS.activos.asignaciones_crear,
            element: <CreateAsignacionesPage />,
          },
          {
            path: ROUTER_PATHS.activos.asignaciones_editar,
            element: <UpdateAsignacionesPage />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.tiketUser.root,
        element: <TiketUserModule />,
        children: [
          {
            path: ROUTER_PATHS.tiketUser.tikets_usuarios,
            element: <TiketsUsuariosPagina />,
          },
          {
            path: ROUTER_PATHS.tiketUser.ver_tikets_usuarios,
            element: <VerTiketsUsuariosPagina />,
          },
          {
            path: ROUTER_PATHS.tiketUser.tikets_usuarios_crear,
            element: <CreateTiketUsuariosPage />,
          },
        ],
      },
      ///marketing
      {
        path: ROUTER_PATHS.marketing.root,
        element: <MarketingModule />,
        children: [
          {
            path: ROUTER_PATHS.marketing.solicitudesCanjeEventoNav,
            element: <SolicitudEventoCanjePage />,
          },
          {
            path: ROUTER_PATHS.marketing.solicitudesCanjeEventoCrearNav,
            element: <CreateSolicitudesEventoCanje />,
          },
          {
            path: ROUTER_PATHS.marketing.solicitudesCanjeEditar,
            element: <EditSolicitudesCanje />,
          },
          {
            path: ROUTER_PATHS.marketing.solicitudesEventoEditar,
            element: <EditSolicitudesEvento />,
          },
          {
            path: ROUTER_PATHS.marketing.revisarSolicitudesCanjeEventoNav,
            element: <RevisionEventoCanjePage />,
          },

          {
            path: ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoNav,
            element: <SolucionEventoCanjePage />,
          },
          {
            path: ROUTER_PATHS.marketing.solucionSolicitudesCanjeEventoEdit,
            element: <SolicitudesPendientesCorporativosEdit />,
          },
        ],
      },
      {
        path: "/campanas",
        element: <CampanasModule />,
        children: [
          {
            index: true,
            element: <CampanasPage />,
          },
          {
            path: "cobranzas",
            element: <CobranzasPage />,
          },
          {
            path: "firma-adendum",
            element: <FirmaAdendumPage />,
          },
          {
            path: "fidelizacion-campana",
            element: <FidelizacionCampanaPage />,
          },
        ],
      },

      ///marketing
      {
        path: ROUTER_PATHS.solucionesDigitales.root,
        element: <SolucionesDigitalesModule />,
        children: [
          {
            path: ROUTER_PATHS.solucionesDigitales.servicios_nav,
            element: <ServiciosDigitalesPage />,
          },
          {
            path: ROUTER_PATHS.solucionesDigitales.servicios_crear,
            element: <CreateServiciosDigitales />,
          },
          {
            path: ROUTER_PATHS.solucionesDigitales.servicios_editar,
            element: <EditServiciosDigitales />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.reportes.root,
        element: <ReportesModule />,
        children: [
          {
            path: "ventas-generales",
            element: <ReporteVentaPage />,
          },
          {
            path: "vendedores-externos-callcenter",
            element: <ReporteVendedoresExternosPage />,
          },
          {
            path: "contratos-pendientes",
            element: <ReporteContratosPendientesPage />,
          },
          {
            path: "comisiones",
            element: <ReporteComisionesPage />,
          },
          {
            path: "clientes-valores-softnet",
            element: <ReporteClientesValoresPage />,
          },
          {
            path: "contratos-softnet",
            element: <ReportesContratosPage />,
          },
          {
            path: "contratos-golondrinas",
            element: <ReportesContratosGolondrinasPage />,
          },
          {
            path: ROUTER_PATHS.reportes.reporteActividadInventario,
            element: <ReporteActividadInventarioPage />,
          },
          {
            path: "equipos-sin-movimiento",
            element: <EquiposSinMovimientoPage />,
          },
        ],
      },
      {
        path: ROUTER_PATHS.noc.root,
        element: <NocModule />,
        children: [
          {
            path: ROUTER_PATHS.noc.ordenesDeTrabajoNocListaNav,
            element: <OrdenesTrabajoNocPage />,
          },
          {
            path: ROUTER_PATHS.noc.ordenesDeTrabajoNocCrearNav,
            element: <CrearOrdenTrabajoNoc />,
          },
          {
            path: ROUTER_PATHS.noc.ordenesDeTrabajoNocEditarNav,
            element: <EditarOrdenTrabajoNoc />,
          },
          {
            path: ROUTER_PATHS.noc.ordenesDeTrabajoNocVerNav,
            element: <VerOrdenTrabajoNoc />,
          },
          {
            path: ROUTER_PATHS.noc.ordenesDeTrabajoNocInformeNav,
            element: <InformeOrdenTrabajoNoc />,
          },
          {
            path: ROUTER_PATHS.noc.ordenesDeTrabajoNocParametrosNav,
            element: <ParametrosOrdenesNocPage />,
          },
          {
            path: ROUTER_PATHS.noc
              .ordenesDeTrabajoNocParametrosTipoActividadCrearNav,
            element: <ParametrosTipoActividadCrearPage />,
          },
          {
            path: ROUTER_PATHS.noc
              .ordenesDeTrabajoNocParametrosTipoActividadEditarNav,
            element: <ParametrosTipoActividadEditarPage />,
          },
          {
            path: ROUTER_PATHS.noc
              .ordenesDeTrabajoNocParametrosIncidenciaCrearNav,
            element: <ParametrosIncidenciaCrearPage />,
          },
          {
            path: ROUTER_PATHS.noc
              .ordenesDeTrabajoNocParametrosIncidenciaEditarNav,
            element: <ParametrosOrdenesNocPage />,
          },
        ],
      },
    ],
  },
]);

export default AppRouter;
